import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { MuiTelInput } from "mui-tel-input";
import "@material-ui/core/styles";
import { Scrollbar } from 'src/components/scrollbar';
import AibdrDetails from "../../dashboard/aibdr/aibdrdetails";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
  InputAdornment,
  Autocomplete,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputLabel,
  ListItem,
  Tabs,
  Tab,
  styled,
  Popper,
  useTheme,
  IconButton,
  CircularProgress,
  Skeleton,
  Pagination,
  Link,
  Tooltip,
  Select,
  MenuItem,
  FormControl
} from "@mui/material";
import axios from "axios";
import {
  getAuth,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import { toast } from "react-hot-toast";
import { toast as toastify } from "react-toastify";
import { CloseOutlined, InfoOutlined } from "@mui/icons-material"
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {
  API_SERVICE_BACKEND,
  cronofy,
  API_SERVICE_BACKEND_2,
  API_SERVICE_BACKEND_3,
  ADMIN_SERVER,
  API_SERVICE_CREDITS,
  HELP_URL
} from "src/config";
import {
  getCanonicalStorageUrl,
  resolveSessionPhotoDisplayUrl,
} from "src/utils/getBlobUrl";
import authAxios from "src/lib/axios";
import { useImagePreview } from "src/hooks/use-image-preview";
import {
  AvailabilityRulesWrapper,
  CalendarSyncWrapper,
} from "src/components/cronofy";
import moment from "moment-timezone";
import LinkIcon2 from "@mui/icons-material/Link";
import User01Icon from "@untitled-ui/icons-react/build/esm/User01";
import { useRef } from "react";
import { thunks } from "src/thunks/mail";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "src/contexts/auth/firebase-context";
import { cronofyApi } from "src/api/cronofy";
import { jobsApi } from "../../../api/jobs";
import EmailAccounts from "./email-accounts/emailAccounts";
import { option } from "../../../assets/data";
import { getSessionStorage, setSessionStorage } from "src/utils/storage";
import BlackList from "./blacklist/blackList";
import CampaignSchedule from "./campaignSchedule/campaign-schedule";
import IntegrationSettings from "./general-settings/integrations";
import Credits from "./credits/credits";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import "./style.css";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { AiOutlineLink } from "react-icons/ai";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { LuCalendarPlus } from "react-icons/lu";
import { MdOutlineWatchLater } from "react-icons/md";
import { WhiteLabelConfigurationContext } from "src/contexts/ClientConfiguration";
import { Seo } from "src/components/seo";
import { CustomSwitch } from "src/components/custom-switch";
import { SettingsContext } from "src/contexts/settings-context";
import PricingPage from "src/pages/PricingPageComponent";
import SubscriptionCard from "./CurrentSubscriptionCard";
import { useUserDetail } from "src/hooks/react-query/useAuth";
import { uploadToBlobStorage } from "src/utils/uploadToBlobStorage";
import { removeFileFromAzure } from "src/utils/upload-files";
import HelperLink from "src/components/HelperLink";

function CompanyLogoUpload({ email, companyLogo, showAlert }) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [imageRemoveDialog, setImageRemoveDialog] = React.useState(false);
  const hiddenFileInput = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const handleClose = () => {
    setDialogOpen(false);
  };

  // image upload
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);
  const [filePreview, setFilePreview] = useState(null);

  const selectFile = (e, fileType) => {
    setIsUploadingFile(true);
    const file = e.target.files[0];
    setOriginalImage(file);
    const preview = URL.createObjectURL(file);
    setFilePreview(preview);
    setDialogOpen(true);
    setIsUploadingFile(false);
  };

  // crop
  const [crop, setCrop] = useState();
  const aspectRatio = 1 / 1;

  function onImageLoad(e) {
    const { width, height } = e.currentTarget;

    const crop = centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 100,
        },
        aspectRatio,
        width,
        height
      ),
      width,
      height
    );

    setCrop(crop);
  }
  // this ref is passed to the image inside the crop modal
  const cropRef = useRef(null);
  const [cropResult, setCropResult] = useState(null);

  useEffect(() => {
    // once we saved our crop, we now need to process this new image size
    if (cropRef.current && crop.width && crop.height) {
      getCroppedImg();
    }
  }, [crop]);

  const getCroppedImg = () => {
    const image = cropRef.current;
    const cropWidth = image.naturalWidth * (crop.width / 100);
    const cropHeight = image.naturalHeight * (crop.height / 100);
    const startX = image.naturalWidth * (crop.x / 100);
    const startY = image.naturalHeight * (crop.y / 100);


    const canvas = document.createElement("canvas");
    canvas.width = cropWidth;
    canvas.height = cropHeight;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      startX,
      startY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight
    );

    const reader = new FileReader();
    canvas.toBlob(
      (blob) => {
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          dataURLtoFile(reader.result, originalImage.name);
        };
      },
      "image/jpeg",
      1
    );
  };

  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let croppedImage = new File([u8arr], filename, { type: mime });
    setCropResult(croppedImage);
  };
  const [updatedProfileImage, setUpdatedProfileImage] = useState(companyLogo);
  useEffect(() => {
    if (companyLogo !== getSessionStorage("photoUrl")) {
      setUpdatedProfileImage(getSessionStorage("photoUrl") || companyLogo);
    } else {
      setUpdatedProfileImage(companyLogo);
    }
  }, [companyLogo]);

  const displayUrlForAvatar =
    (updatedProfileImage || companyLogo || "").trim() || null;
  const companyLogoAvatarPreview = useImagePreview(displayUrlForAvatar, {
    axiosInstance: authAxios,
    fallbackToRawOnError: true,
  });

  const handleUpload = async () => {
    try {
      setIsUploadingFile(true);
      let image = cropResult;
      let formData = new FormData();
      if (image.size <= 2 * 1024 * 1024) {
        // 2 MB in bytes
        formData.append("file", image);
      } else {
        toast.error("Image size exceeds 2 MB");
        console.error("Image size exceeds 2 MB");
        return;
      }

      // const response = await axios.post(
      //   `${API_SERVICE_BACKEND_2}/upload`,
      //   formData
      // );
      // upload on azure blob storage
      const blobname = `${Date.now()}_${formData.get("file").name}`;
      const imageUrl = await uploadToBlobStorage(image, blobname, "profile-image");

      const request = { profile_image: imageUrl };
      const uploadResponse = await axios.put(
        `${API_SERVICE_BACKEND_2}/updateuserprofileimage/${email}`,
        request
      );
      if (uploadResponse.data.status === true) {
        toast.success("Image updated successfully");
      }
      const profileImage = uploadResponse.data?.data?.profile_image;
      const displayPhoto = profileImage
        ? await resolveSessionPhotoDisplayUrl(profileImage)
        : "";
      setUpdatedProfileImage(displayPhoto);
      setSessionStorage("photoUrl", displayPhoto);
      navigate(`${location.pathname}`);

    } catch (error) {
      //console.log("error", error);
    } finally {
      setIsUploadingFile(false);
    }
    setDialogOpen(false);
  };

  const handleDeleteImage = async () => {
    try {
      setIsUploadingFile(true);
      const displayRef = updatedProfileImage ? updatedProfileImage : companyLogo;
      const fileUrl = getCanonicalStorageUrl(displayRef) || displayRef;

      const response = await removeFileFromAzure(fileUrl);
      if (response.status === true) {
        const request = {
          profile_image: "",
        };
        const uploadResponse = await axios.put(
          `${API_SERVICE_BACKEND_2}/deleteUserProfileImage/${email}`,
          request
        );
        if (uploadResponse.data.status === true) {
          toast.success("Image removed successfully");
        }
        setUpdatedProfileImage(null);
        setSessionStorage("photoUrl", null);
        setImageRemoveDialog(false);
        navigate(`${location.pathname}`);
      } else {
        toast.error("Error removing image");
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setIsUploadingFile(false);
    }
  };

  return (
    <>
      <Stack sx={{ mt: 0 }} direction="column" spacing={2}>
        <Typography sx={{ fontSize: "14px", color: theme.palette.text.primary }}>
          Company Logo
        </Typography>
        <Stack
          direction={"row"}
          gap={1}
          justifyContent={"flex-start"}
          alignItems={"center"}
        >
          <Avatar
            sx={{
              height: 50,
              width: 50,
              color: theme.palette.text.primary
            }}
            src={updatedProfileImage || companyLogo || undefined}
          >
            <SvgIcon>
              <User01Icon />
            </SvgIcon>
          </Avatar>
          <Stack>
            <Stack
              direction={"row"}
              gap={1}
              justifyContent={"flex-start"}
              alignItems={"center"}
            >
              <Button
                sx={{
                  width: "fit-content",
                  p: 0,
                  fontWeight: 500,
                  fontSize: "14px",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                className="glass-button-tertiary"
                disabled={showAlert ? true : false}
                disableTouchRipple
                onClick={() => {
                  hiddenFileInput.current.value = null;
                  hiddenFileInput.current.click();
                }}
              >
                {updatedProfileImage
                  ? `Update your Company Logo`
                  : `Upload your Company Logo`}
              </Button>
              <input
                name="cover"
                type="file"
                disabled={showAlert ? true : false}
                onChange={(e) => selectFile(e, "cover")}
                ref={hiddenFileInput}
                accept="image/png, image/jpeg"
                style={{ display: "none" }}
              />

              {updatedProfileImage && (
                <>
                  <Divider
                    orientation="vertical"
                    variant="middle"
                    flexItem
                    style={{ borderColor: "rgba(0,0,0,0.5)" }}
                  />
                  <Button
                    // sx={{
                    //   width: "fit-content",
                    //   p: 0,
                    //   fontWeight: 500,
                    //   fontSize: "14px",
                    //   color: "red",
                    //   "&:hover": {
                    //     backgroundColor: "transparent",
                    //   },
                    // }}
                    variant="contained"
                    sx={{
                      fontWeight: 500,
                      fontSize: "14px",
                      p: 0,
                      width: "fit-content",
                      backgroundColor: "red",
                      "&:hover":
                      {
                        backgroundColor: "#e30000"
                      },
                    }}
                    //className="glass-button-secondary-25"
                    disableTouchRipple
                    disabled={showAlert ? true : false}
                    onClick={() => setImageRemoveDialog(true)}
                  >
                    Remove
                  </Button>
                </>
              )}
            </Stack>
            <Typography
              sx={{
                fontSize: "12px",
                color: theme.palette.text.secondary

              }}
            >
              Logo should be in the standard format png. jpg & no more than 2MB
              {/* Upload image in PNG or JPG, with a file size under 2MB. */}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogContent>
          <Stack>
            <ReactCrop
              crop={crop}
              onChange={(c, percentCrop) => setCrop(percentCrop)}
              aspect={aspectRatio}
            //style={{ width: 300 }}
            >
              <img
                src={filePreview}
                ref={cropRef}
                onLoad={onImageLoad}
                alt="Your uploaded image"
              />
            </ReactCrop>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button className="glass-button-tertiary" disabled={isUploadingFile} onClick={handleUpload}>{isUploadingFile ? "Uploading..." : "Save Logo"}</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={imageRemoveDialog}>
        <DialogTitle id="alert-dialog-title"
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h6" sx={{ display: "flex", alignItems: "center", color: theme.palette.text.primary }}>Remove Image</Typography>
          <IconButton onClick={() => setImageRemoveDialog(false)} sx={{ color: theme.palette.text.primary }}>
            <CloseOutlined />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ color: theme.palette.text.secondary }}>
            Are you sure you want to remove the company logo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="glass-button-secondary-50" onClick={() => setImageRemoveDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleDeleteImage} disabled={isUploadingFile} sx={{ backgroundColor: "red", "&:hover": { backgroundColor: "#e30000" }, }}>
            {isUploadingFile ? "Removing..." : "Remove"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const CalendarPanel = ({
  section7Ref,
  conferencingLinked,
  handleConferencingLink,
  calendarOptions,
  email,
  availabilityElements,
  userCampaigns,
  location,
  navigate,
  userCampaignLoading,
  activeSubTab,
  setActiveSubTab
}) => {

  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setActiveSubTab((prev) => newValue);
  };
  return (
    <Box
      ref={section7Ref}
      id="section7"
      sx={{

        borderRadius: "8px",
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
        backgroundColor: theme.palette.background.paper,
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
      className="glass-wrapper"
    >
      <Box
        sx={{
          borderBottom: `1px solid ${theme.palette.divider}`,
          px: 1,
          py: 0,
          pb: 1,
          pt: 1
        }}
      >
        <Tabs
          value={activeSubTab ?? 0}
          onChange={handleChange}
          aria-label="basic tabs example"
          className="glass-tabs"
          sx={{
            width: "fit-content",
            "& .MuiTab-root": {
              color: theme.palette.text.primary,
              "&.Mui-selected": {
                color: theme.palette.primary.main,
              },
              pb: "16px",
              // pt: "20px",
              pt: "16px",
              pl:"8px"
            },
          }}

        >
          <Tab label="Global Calendar" {...a11yProps(0)} />
          <Tab label="AI Agent Calendars" {...a11yProps(1)} />
        </Tabs>
      </Box>

      <Box
        sx={{
          overflowY: "auto",
          maxHeight: "calc(100vh - 220px)",
          // px: 2,
          // py: 2,
        }}
        component={Scrollbar}
      >
        <CustomTabPanel value={activeSubTab} index={0}>
          <Stack spacing={2}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "15px",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <>
                    {/* <img
                    src={calenderPlus}
                    style={{ marginRight: "10px", height: "23px" }}
                  /> */}
                    <LuCalendarPlus
                      style={{
                        fontSize: "22px",
                        color: theme.palette.text.primary,
                      }}
                    />
                  </>

                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: theme.palette.text.primary,
                    }}
                  >
                    Global Calendar
                  </Typography>
                  {!conferencingLinked.linked && (
                    <Chip
                      size="small"
                      color="error"
                      label="Link meeting platform"
                      // className="glass-chip"
                      onClick={() => {
                        handleConferencingLink(conferencingLinked.accessToken);
                      }}
                      icon={<LinkIcon2 style={{ color: "white" }} />}
                    />
                  )}
                </Box>
                {/* <Box
                  sx={{
                    textAlign: "left",
                    ml: 1,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "13px",
                      fontWeight: 500,
                      color: (theme) => theme.palette.text.secondary,
                      lineHeight: "18px",
                      display: "inline",
                    }}
                  >
                    Keep every meeting in sync—link your calendar.{" "}
                    <Link
                      href={`${HELP_URL}/11536896-calendar-settings-view-configure-availability#h_f4b70eff70`}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        fontSize: "13px",
                        fontWeight: 600,
                        lineHeight: "18px",
                        color: (theme) => theme.palette.primary.main,
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                        display: "inline",
                      }}
                    >
                      [Learn how to connect]
                    </Link>
                  </Typography>
                </Box> */}
                <HelperLink
                  helperText={"Keep every meeting in sync—link your calendar. "}
                  actionText={"Learn how to connect"}
                  style={{
                    textAlign: "left",
                    ml: 1,
                  }}
                />

              </div>
              <Divider />
              <div style={{ marginTop: "20px" }}>
                <CalendarSyncWrapper options={calendarOptions} email={email} />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {Boolean(availabilityElements.length) && (
                <div
                  // ref={section8Ref}
                  // id="section8"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: "15px",
                    }}
                  >
                    <>
                      {/* <img
                        src={SelectIcon}
                        style={{ marginRight: "10px", height: "23px" }}
                      /> */}

                      <MdOutlineWatchLater
                        style={{
                          marginRight: "10px",
                          fontSize: "24px",
                          color: theme.palette.primary.main,
                        }}
                      />

                    </>
                    <Typography
                      sx={{
                        fontWeight: "700",
                        fontSize: "16px",
                        color: theme.palette.text.primary,
                      }}
                    >
                      {/* Select Your Availability */}
                      Set Working Hours / Availability
                    </Typography>
                  </div>
                  <Divider />
                  <div id="availability-grid" style={{ marginTop: "20px" }}>
                    {availabilityElements.map((element) => element)}
                  </div>
                </div>
              )}
              <SlotPresetSetting />
            </div>
          </Stack>
        </CustomTabPanel>
        <CustomTabPanel value={activeSubTab} index={1}>
          <div
            // ref={section10Ref}
            // id="section10"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "15px",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <>
                  <LuCalendarPlus
                    style={{
                      marginRight: "10px",
                      fontSize: "22px",
                      color: theme.palette.text.primary,
                    }}
                  />
                </>
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: theme.palette.text.primary,
                  }}
                >
                  AI Agent Calendars
                </Typography>
              </Box>
              {/* <Box
                sx={{
                  textAlign: "left",
                  ml: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 500,
                    color: (theme) => theme.palette.text.secondary,
                    lineHeight: "18px",
                    display: "inline",
                  }}
                >
                  Set separate calendars for each AI Agent.{" "}
                  <Link
                    href={`${HELP_URL}/11516751-ai-agent-calendars-view-manage-agent-schedules#h_be93f6219c`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontSize: "13px",
                      fontWeight: 600,
                      lineHeight: "18px",
                      color: (theme) => theme.palette.primary.main,
                      textDecoration: "none",
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "inline",
                    }}
                  >
                    [Learn how to set up]
                  </Link>
                </Typography>
              </Box> */}
              <HelperLink
                helperText={"Set separate calendars for each AI Agent. "}
                actionText={"Learn how to set up"}
                style={{
                  textAlign: "left",
                  ml: 1,
                }}
              />

            </div>
            <Divider />

            <div style={{ marginTop: "20px" }}>
              <Stack
                // alignItems="center"
                // direction="column"
                sx={{
                  // border: "1px solid #EAECF0",
                  // borderRadius: "12px",
                  // padding: "5px",
                }}
                gap={"8px"}
              >
                {!userCampaignLoading ? userCampaigns?.map((campaign, index) => {
                  return (
                    <>
                      <Box
                        sx={{
                          width: "100%",
                          // border: "1px solid #EAECF0",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingX: "10px",
                        }}
                      >
                        <Typography 
                        style={{  
                          flex: 1,
                          minWidth: 0,
                          fontSize: "14px",
                          color: theme.palette.text.primary,
                          marginRight: "10px"
                           }}>
                          <b>{campaign.companyName ? campaign.companyName + " " : ""}</b>
                          {campaign.companyName && campaign.title ? " - " : ""}
                          {campaign.title ? campaign.title : ""}
                          {campaign.responsibility ? (
                            <span style={{ fontSize: "12px", color: theme.palette.text.primary }}>
                              {campaign.companyName || campaign.title
                                ? " (" + campaign.responsibility + ")"
                                : campaign.responsibility}
                            </span>
                          ) : null}
                        </Typography>

                        <Button
                          variant={"outlined"}
                          sx={{
                            color: theme.palette.text.primary,
                            border: `1px solid ${theme.palette.divider}`,
                            // marginRight: "10px",
                            // marginLeft: "5px",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            minWidth: "110px",   
                            flexShrink: 0,

                          }}
                          className="glass-button-secondary-50"
                          onClick={() => {
                            // //console.log(
                            //   "props extrra -------->",
                            //   campaign.extra
                            // );
                            navigate(
                              `${location.pathname}?campaign_id=${campaign._id}&title=${campaign.title}`,
                              { state: { extra: campaign.extra } }
                            );
                          }}
                        >
                          {/* {campaign.extra
                            ? "Connected"
                            : "Not Connected"} */}
                          View More
                        </Button>
                      </Box>
                    </>
                  );
                }) : userCampaignLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100px" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      color: theme.palette.text.primary,
                      fontSize: "14px",
                      fontWeight: "500",
                    }}
                  >
                    No AI Agent Calendars
                  </Typography>)
                }
              </Stack>
            </div>
          </div>
        </CustomTabPanel>
      </Box>
    </Box>
  );
};

async function generateHMAC(message, key) {
  const encoder = new TextEncoder();
  const keyData = encoder.encode(key);
  const messageData = encoder.encode(message);

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyData,
    { name: "HMAC", hash: { name: "SHA-256" } },
    false,
    ["sign"]
  );

  const signature = await crypto.subtle.sign("HMAC", cryptoKey, messageData);
  return Array.from(new Uint8Array(signature))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

const hash = await generateHMAC(
  getSessionStorage("userEmail"),
  process.env.REACT_APP_INTERCOM_HASH_KEY
);

export const UserMeetingSchedules = ({ date, index }) => {
  const meetingTime = [
    "09:00AM",
    "11:00AM",
    "01:00PM",
    "03:00PM",
    "04:00PM",
    "09:30AM",
    "11:30AM",
    "01:30PM",
    "02:30PM",
    "04:30PM",
    "09:45AM",
    "11:45AM",
    "01:45PM",
    "02:45PM",
    "03:45PM",
    "09:15AM",
    "11:30AM",
    "01:30PM",
    "03:15PM",
    "04:15PM",
    "10:00AM",
    "11:15AM",
    "01:15PM",
    "02:45PM",
    "03:30PM",
  ];
  const selectedTimeSlots = meetingTime.slice(index * 5, index * 5 + 5);

  return (
    <>
      <Grid>
        <Stack alignItems="center" direction="row" spacing={3}>
          <TextField
            type="text"
            defaultValue={date}
            sx={{ mt: 1 }}
            variant="outlined"
            disabled={true}
            className="glass-input"
          />

          {selectedTimeSlots.map((time, timeIndex) => (
            <TextField
              key={timeIndex}
              defaultValue={time}
              variant="outlined"
              sx={{ mt: 2, display: "none" }}
              type="text"
              disabled={true}
              className="glass-input"
            />
          ))}
        </Stack>
      </Grid>
    </>
  );
};

let campaignMaxCallsAllowedToGetAccessToken = 3;
const now = new Date();
const campaignSaveToDB = async (email, key, value, campaign_id) => {
  // //console.log(key, value)
  // const res = await axios.patch(`${API_SERVICE_BACKEND}/patchUser`, {
  const res = await axios.patch(`${API_SERVICE_BACKEND}/patchCampaign`, {
    email,
    campaign_id,
    payload: {
      [key]: { generatedAt: Date.now(), ...value },
    },
  });
  // //console.log("res.data", res.data);
  if (res.status !== 200) return false;
  return true;
};
function formatDate(date) {
  // Extract date components
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();

  // Extract time components
  let hours = date.getHours();
  let minutes = date.getMinutes().toString().padStart(2, "0");

  // Determine AM/PM
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // The hour '0' should be '12'
  hours = hours.toString().padStart(2, "0");

  // Combine date and time components
  let formattedDate = `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  return formattedDate;
}

const CampaignSlotPresetSetting = ({ campaignId }) => {
  const [duration, setDuration] = useState(0);
  const checkFirstRender = useRef(true);
  const [buffer, setBuffer] = useState({
    isSetBuffer: false,
    before: 0,
    after: 0,
  });
  const [minimumNotice, setMinimumNotice] = useState(null);
  const [scheduleTime, setScheduleTime] = useState(null);
  const [dateOption, setDateOption] = useState(null);
  const [scheduleVisibility, setScheduleVisibility] = useState("");
  const [scheduleDate, setScheduleDate] = useState(null);
  const [minimumNoticeTime, setMinimumNoticeTime] = useState(null);
  const theme = useTheme();

  const email = getSessionStorage("userEmail");
  const handleDurationChange = async (event) => {
    const targetValue = event.target.value;
    setDuration(targetValue);
  };

  const durationTime = async () => {
    /*const userSlotPreset = await fetch1(
      `${API_SERVICE_BACKEND_3}/get-campaign-slot-preset/${campaignId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );*/
    const userSlotPreset = await axios.get(
      `${API_SERVICE_BACKEND_3}/get-campaign-slot-preset/${campaignId}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const duration = userSlotPreset.data;
    setDuration(duration?.data?.slotsPreset);

    if (duration?.data?.buffer) {
      setBuffer(duration?.data?.buffer);
    }
    setDuration(duration?.data?.slotsPreset);
    let scheduleVisible = duration?.data?.schedulingOption
      ? duration?.data?.schedulingOption
      : "rolling";
    setScheduleVisibility(scheduleVisible);
    if (duration?.data?.schedulingOption === "rolling") {
      setScheduleTime(duration?.data?.rollingTime.split(" ")[0]);
      setDateOption(duration?.data?.rollingTime.split(" ")[1]);
    } else if (duration?.data?.schedulingOption === "custom") {
      let maxScheduleDate = new Date(duration?.data?.maximumSchedulingTime);
      maxScheduleDate.setDate(maxScheduleDate.getDate() - 1);
      setScheduleDate(maxScheduleDate);
    }

    let minimumNoticeDate = duration?.data?.minimumNotice;
    if (minimumNoticeDate && new Date(minimumNoticeDate) > new Date()) {
      let minimumNoticeTime = new Date(duration?.data?.minimumNotice);
      setMinimumNoticeTime(formatDate(minimumNoticeTime));
      let diff = new Date(minimumNoticeDate) - new Date();
      setMinimumNotice(Math.ceil(diff / 1000 / 60 / 60));
    }
  };
  useEffect(() => {
    durationTime();
  }, []);

  useEffect(() => {
    if (duration) {
      if (checkFirstRender.current) {
        checkFirstRender.current = false;
        return;
      }
      (async () => {
        /*const res = await fetch1(
          `${API_SERVICE_BACKEND_3}/updateCampaignSlotPreset/${campaignId}/${duration}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );*/
        const res = await axios(
          {
            method: "PUT",
            url: `${API_SERVICE_BACKEND_3}/updateCampaignSlotPreset/${campaignId}/${duration}`,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (res.status === 200) {
          toast.success("Slot Preset Updated Successfully");
        } else {
          toast.error("Error Updating Slot Preset");
        }
      })();
    }
  }, [duration]);

  const handleBufferChange = (event) => {
    const { name, value } = event.target;
    setBuffer((prevState) => ({
      ...prevState,
      [name]: Number(value),
    }));
  };

  const handleBufferVisibilityChange = async (event) => {
    setBuffer((prevState) => ({
      ...prevState,
      isSetBuffer: !buffer.isSetBuffer,
    }));

    if (event.target.value === "false") {
      const res = await updateSlotPreset(false);
      if (res.status === 200) {
        toast.success("Buffer Updated Successfully");
      } else {
        toast.error("Error Updating Buffer");
      }
    }
  };

  const updateSlotPreset = async (isSetBuffer) => {
    /*return await fetch1(
      `${API_SERVICE_BACKEND_3}/updateCampaignSlotPreset/${campaignId}/${duration}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...buffer,
          isSetBuffer: isSetBuffer ?? buffer.isSetBuffer,
        }),
      }
    );*/
    return await axios.put(
      `${API_SERVICE_BACKEND_3}/updateCampaignSlotPreset/${campaignId}/${duration}`,
      {
        ...buffer,
        isSetBuffer: isSetBuffer ?? buffer.isSetBuffer,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  };

  const handleSaveBuffer = () => {
    (async () => {
      const res = await updateSlotPreset();
      if (res.status === 200) {
        toast.success("Buffer Updated Successfully");
      } else {
        toast.error("Error Updating Buffer");
      }
    })();
  };
  const handleMinimumNotice = async () => {
    if (!minimumNotice) {
      toast.error("Please enter minimum notice time");
      return;
    }
    let minimum_notice = new Date();
    minimum_notice.setHours(minimum_notice.getHours() + minimumNotice);
    if (minimumNotice === 0) {
      minimum_notice = null;
    }
    const res = await axios.post(
      `${API_SERVICE_BACKEND_3}/updateCampaignMinimumNotice/${campaignId}`,
      { minimum_notice },
      {
        minimumNotice,
      }
    );
    if (res.status === 200) {
      if (minimum_notice && minimum_notice > new Date()) {
        setMinimumNoticeTime(formatDate(minimum_notice));
        let diff = new Date(minimum_notice) - new Date();
        setMinimumNotice(Math.ceil(diff / 1000 / 60 / 60));
      }
      toast.success("Minimum Notice updated successfully!!");
    } else {
      toast.error("Error Updating Minimum Notice Time");
    }
  };
  const removeMinimumNotice = async () => {
    const res = await axios.post(
      `${API_SERVICE_BACKEND_3}/updateCampaignMinimumNotice/${campaignId}`,
      { minimum_notice: null }
    );
    if (res.status === 200) {
      setMinimumNotice("");
      setMinimumNoticeTime(null);
      toast.success("Minimum Notice removed successfully!!");
    } else {
      toast.error("Error Removing Minimum Notice Time");
    }
  };
  const dateOptions = ["Day", "Week", "Month"];

  const handleSchedulingDate = (event, value) => {
    setDateOption(value);
  };
  const handleScheduleVisibility = async (event) => {
    setScheduleVisibility(event.target.value);
  };
  const handleSchedulingCalendar = async (event) => {
    setScheduleDate(event);
  };

  const handleMaxScheduleTime = async () => {
    if (!scheduleVisibility) {
      toast.error("Please select the above options");
      return;
    }
    let res;
    if (scheduleVisibility === "rolling") {
      if (!scheduleTime || !dateOption) {
        toast.error("Please select the rolling period");
        return;
      }
      res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateCampaignMaximumSchedulingTime/${campaignId}`,
        {
          scheduleTime: parseInt(scheduleTime),
          dateOption: dateOption,
          option: scheduleVisibility,
        }
      );
      if (res.status === 200) {
        setScheduleTime(parseInt(scheduleTime));
        setScheduleDate(null);
        toast.success("Maximum Scheduling Time updated successfully!!");
      } else {
        toast.error("Error Updating Maximum Scheduling Time");
      }
    } else {
      if (!scheduleDate) {
        toast.error("Please select the date");
        return;
      }
      res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateCampaignMaximumSchedulingTime/${campaignId}`,
        {
          scheduleDate: scheduleDate,
          option: scheduleVisibility,
        }
      );
      if (res.status === 200) {
        setScheduleDate(scheduleDate);
        setScheduleTime("");
        toast.success("Maximum Scheduling Time updated successfully!!");
      } else {
        toast.error("Error Updating Maximum Scheduling Time");
      }
    }
  };

  const removeMaxScheduleTime = async () => {
    if (scheduleVisibility === "rolling") {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateCampaignMaximumSchedulingTime/${campaignId}`,
        {
          scheduleTime: null,
          dateOption: null,
          option: null,
        }
      );
      if (res.status === 200) {
        setScheduleTime("");
        setDateOption(null);
        toast.success("Maximum Scheduling Time removed successfully!!");
      } else {
        toast.error("Error Removing Maximum Scheduling Time");
      }
    } else {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateCampaignMaximumSchedulingTime/${campaignId}`,
        {
          scheduleDate: null,
          option: null,
        }
      );
      if (res.status === 200) {
        setScheduleDate(null);
        toast.success("Maximum Scheduling Time removed successfully!!");
      } else {
        toast.error("Error Removing Maximum Scheduling Time");
      }
    }
  };

  const CustomPopper = styled(Popper)(({ theme }) => ({
    "& .MuiAutocomplete-listbox": {
      fontSize: "14px", // Change this value to set your desired font size
    },
  }));

  return (
    <>
      {/* <FormLabel component="legend">Select Slot Preset</FormLabel> */}
      <RadioGroup
        onChange={handleDurationChange}
        row
        aria-label="duration"
        name="duration"
        value={duration}
      >
        <FormControlLabel
          value={15}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>15 Minutes</Typography>
          }
        />
        <FormControlLabel
          value={30}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>30 Minutes</Typography>
          }
        />
        <FormControlLabel
          value={60}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>60 Minutes</Typography>
          }
        />
      </RadioGroup>

      <Divider />

      <Grid
        item
        container
        direction="row"
        gap={2}
        alignItems={"center"}
        marginTop={"10px"}
      >
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Buffer Time:
        </Typography>

        <RadioGroup
          onChange={handleBufferVisibilityChange}
          row
          aria-label="buffer"
          value={buffer.isSetBuffer}
          name={"isSetBuffer"}
        >
          <FormControlLabel value={false} control={<Radio />} label="No" />
          <FormControlLabel value={true} control={<Radio />} label="Yes" />
        </RadioGroup>
      </Grid>

      {buffer && buffer.isSetBuffer && (
        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item container direction="row" gap={2}>
            <Box display={"flex"} flexDirection={"row"} width={"100%"} gap={5}>
              <Grid item container alignItems="center" columnSpacing={1}>
                <Typography sx={{ marginRight: "8px", fontSize: "14px", color: theme.palette.text.primary }}>
                  before :{" "}
                </Typography>
                <TextField
                  name={"before"}
                  value={buffer?.before}
                  variant="outlined"
                  size="small"
                  type="number"
                  max={60}
                  error={buffer?.before > 60}
                  helperText={
                    buffer?.before > 60 && "maximum buffer time should be 60"
                  }
                  sx={{ flexGrow: 1 }}
                  inputProps={{ min: 0 }}
                  onChange={handleBufferChange}
                  className="glass-input"
                />
              </Grid>

              <Grid item container alignItems="center" columnSpacing={1}>
                <Typography sx={{ marginRight: "8px", fontSize: "14px", color: theme.palette.text.primary }}>
                  after :{" "}
                </Typography>
                <TextField
                  name={"after"}
                  value={buffer?.after}
                  variant="outlined"
                  size="small"
                  type="number"
                  max={60}
                  error={buffer?.after > 60}
                  helperText={
                    buffer?.after > 60 && "maximum buffer time should be 60"
                  }
                  sx={{ flexGrow: 1 }}
                  inputProps={{ min: 0 }}
                  onChange={handleBufferChange}
                  className="glass-input"
                />
              </Grid>
            </Box>
            <Grid item container alignItems="center" columnSpacing={1}>
              <Button
                sx={{ marginRight: "8px", fontSize: "14px" }}
                className="glass-button-secondary-50"
                disabled={buffer?.after > 60 || buffer?.before > 60}
                variant={"outlined"}
                size={"small"}
                onClick={handleSaveBuffer}
              >
                Save buffer{" "}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Divider sx={{ marginY: "10px" }} />
      <Grid item container gap={2} direction="column" marginTop={"10px"}>
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Maximum Scheduling Time
        </Typography>
        <RadioGroup
          onChange={handleScheduleVisibility}
          row
          aria-label="Schedule Time"
          value={scheduleVisibility}
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="rolling"
            control={<Radio />}
            label={
              <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>
                Over a period of rolling time
              </Typography>
            }
          />
          <FormControlLabel
            value="custom"
            control={<Radio />}
            label={
              <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>Custom date</Typography>
            }
          />
        </RadioGroup>
        {scheduleVisibility === "rolling" ? (
          <Grid container alignItems="center" columnSpacing={2}>
            <Grid item container direction="row" gap={2}>
              <Grid item container alignItems="center" columnSpacing={1}>
                <TextField
                  placeholder="Enter Period"
                  value={scheduleTime}
                  variant="outlined"
                  id="outlined-basic"
                  size="small"
                  type="number"
                  sx={{ flexGrow: 1 }}
                  className="glass-input"
                  inputProps={{ min: 1 }}
                  onChange={(e) => setScheduleTime(parseInt(e.target.value))}
                />
              </Grid>

              <Autocomplete
                options={dateOptions}
                sx={{
                  width: "50%",
                  "& .MuiAutocomplete-listbox": {
                    fontSize: "14px",
                  },
                }}
                className="glass-input"
                size="small"
                variant="outlined"
                id="outlined-basic"
                PopperComponent={CustomPopper}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant={"outlined"}
                    placeholder="Select"
                  />
                )}
                onChange={handleSchedulingDate}
                value={dateOption}
              />
              <Grid item container alignItems="center" columnSpacing={2}>
                <Button
                  sx={{ marginRight: "8px" }}
                  className="glass-button-secondary-50"
                  variant={"outlined"}
                  size={"small"}
                  onClick={handleMaxScheduleTime}
                >
                  Set
                </Button>
                <Button
                  sx={{ marginRight: "8px" }}
                  className="glass-button-secondary-50"
                  variant={"outlined"}
                  size={"small"}
                  onClick={removeMaxScheduleTime}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <Grid item container alignItems="center" direction="row" gap="2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Max Date"
                  disablePast
                  value={scheduleDate}
                  onChange={handleSchedulingCalendar}
                  renderInput={(params) => <TextField {...params} />}
                  className="glass-input"
                  PaperProps={{ className: "glass-popup" }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item container alignItems="center" marginTop={2}>
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={handleMaxScheduleTime}
                className="glass-button-secondary-50"
              >
                Set
              </Button>
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={removeMaxScheduleTime}
                className="glass-button-secondary-50"
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
      <Divider sx={{ marginY: "10px" }} />
      <Grid item container gap={2} direction="column" marginTop={"10px"}>
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Minimum Notice Time
        </Typography>
        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item container direction="row" gap={1}>
            <Grid item container alignItems="center" columnSpacing={1}>
              <TextField
                placeholder="In Hours"
                value={minimumNotice}
                variant="outlined"
                size="small"
                type="number"
                sx={{ flexGrow: 1 }}
                className="glass-input"
                inputProps={{ min: 0 }}
                onChange={(e) => setMinimumNotice(parseInt(e.target.value))}
              />
            </Grid>

            <Grid item container alignItems="center">
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={handleMinimumNotice}
                className="glass-button-secondary-50"
              >
                Set
              </Button>
            </Grid>
            <Grid item container alignItems="center">
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={removeMinimumNotice}
                className="glass-button-secondary-50"
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {minimumNoticeTime && (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: theme.palette.text.primary
            }}
          >
            Valid till{" "}
            <span style={{ color: "red", fontWeight: 400 }}>
              {minimumNoticeTime}
            </span>
          </Typography>
        )}
      </Grid>
    </>
  );
};

const CalenderView = (props) => {
  const { user } = useAuth();

  // const [openCalenderDialog, setOpenCalenderDialog] = useState(false);
  const location = useLocation();
  const { whiteLableStatus, subUserStatus, customEmailConfigDomain } = useContext(WhiteLabelConfigurationContext);
  const whiteLabelDomain = "https://" + customEmailConfigDomain;
  const redirect_uri = `${subUserStatus ? whiteLabelDomain : cronofy.redirect_uri}${location.pathname}?from=cronofy`;

  const query = new URLSearchParams(location.search);
  const queryParams = {};
  query.forEach((value, key) => (queryParams[key] = value));

  const { code, from, campaign_id: _id, state, title } = queryParams;
  const extra = location?.state?.extra;
  const myState = JSON.stringify({
    campaign_id: _id,
    title: title,
  });

  const [calendarOptions, setCalendarOptions] = useState({
    data_center: cronofy.data_center,
    target_id: `cronofy-calendar-sync`,
    authorization: {
      redirect_uri,
      client_id: cronofy.client_id,
      scope: "read_write",
      avoid_linking: true,
      state: myState,
    },
    styles: {
      prefix: "CalendarSync",
    },
  });

  const [accessToken, setAccessToken] = useState(null);
  const [conferencingLinked, setConferencingLinked] = useState({
    linked: true,
    accessToken: null,
  });
  const section8Ref = useRef();
  const theme = useTheme();

  const [availabilityOptions, setAvailabilityOptions] = useState({
    target_id: "cronofy-availability-rules",
    data_center: cronofy.data_center,
    availability_rule_id: "work_hours",
    tzid: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  const [dialogState, setDialogState] = useState({
    open: false,
    loadUrl: "",
  });

  const linkConferencingService = async (accessTokenCur) => {
    if (!accessTokenCur) {
      accessTokenCur = accessToken;
    }
    const conferencingService = await cronofyApi.conferencingByCampaign({
      token: accessTokenCur?.access_token,
      redirect_uri: `${redirect_uri}&campaign_id=${_id}&title=${title}`,
      email: getSessionStorage("userEmail"),
      profile_email: accessTokenCur.linking_profile.profile_name,
      campaign_id: _id,
      state: myState,
    });

    if (conferencingService.linked) {
      return;
    }
    if (conferencingService.url) {
      setDialogState({ open: true, loadUrl: conferencingService?.url });
    }
  };

  // link calendar
  useEffect(() => {
    if (!code || from !== "cronofy") {
      if (window.Intercom) {
        window.Intercom("update", {
          email: getSessionStorage("userEmail"),
          user_hash: hash,
          calendar_synced: false,
        });
      }
      return;
    }
    //console.log(` Getting Access Token using the code:`);
    cronofyApi
      .getAccessToken({
        code,
        redirect_uri,
        // redirect_uri,
      })
      .then(async (accessToken) => {
        ////console.log(` Getting Access Token after`, accessToken);
        if (!accessToken) return;
        if (accessToken.linking_profile.provider_name !== "google") {
          await linkConferencingService(accessToken);
        }

        // Saving Access token to db
        if (window.Intercom) {
          window.Intercom("trackEvent", "calendar_synced", {
            email: getSessionStorage("userEmail"),
          });
          window.Intercom("update", {
            email: getSessionStorage("userEmail"),
            user_hash: hash,
            calendar_synced: true,
          });
        }
        const opSuc = campaignSaveToDB(
          user.email,
          "extra.accessToken",
          accessToken,
          _id
        );
        if (!opSuc) throw new Error(" Access Token couldn't be saved");
        setAccessToken(accessToken);
        // navigate(location.pathname, {
        //   replace: true,
        //   preventScrollReset: true,
        // });

        // //console.log(`Getting the Element token using sub from Access token`);
        // const elementToken = await cronofyApi.getElementToken({
        //   sub: accessToken.sub,
        //   permissions: ["account_management"],
        //   origin: cronofy.redirect_uri,
        // });
        // if (!elementToken) return;
        // setCalendarToken(elementToken.element_token.token);
        // navigate(location.pathname, {
        //   replace: true,
        //   preventScrollReset: true,
        // });

        // //console.log(`Getting the Element token using sub from Access token`);
        // const elementToken = await cronofyApi.getElementToken({
        //   sub: accessToken.sub,
        //   permissions: ["account_management"],
        //   origin: cronofy.redirect_uri,
        // });
        // if (!elementToken) return;
        // setCalendarToken(elementToken.element_token.token);
      });
  }, [code]);

  const [availabilityElements, setAvailabilityElements] = useState([]);
  useEffect(() => {
    if (!availabilityOptions.element_token) return;

    setAvailabilityElements((prev) => [
      // ...prev,
      <AvailabilityRulesWrapper
        key="availability-rules"
        options={availabilityOptions}
      />,
    ]);
  }, [availabilityOptions]);
  const getAccessToken = async (_id) => {
    if (!_id) return;
    // //console.log(`Getting the Element token using sub from Access token`);
    campaignMaxCallsAllowedToGetAccessToken -= 1;
    // //console.log(maxCallsAllowedToGetAccessToken);

    const campaign = await jobsApi.getCampaignDetails(_id);
    const userInfo = campaign[0];
    const accessToken = userInfo?.extra?.accessToken;
    if (
      userInfo?.extra?.accessToken?.linking_profile?.provider_name !== "google"
    ) {
      const conferencingArray = userInfo?.extra?.conferencing_linked?.find(
        (item) => item.email === accessToken?.linking_profile.profile_name
      );
      if (conferencingArray) {
        setConferencingLinked({
          linked: true,
          accessToken: accessToken,
        });
      } else {
        setConferencingLinked({
          linked: false,
          accessToken: accessToken,
        });
      }
    }
    if (accessToken) {
      if (window.Intercom) {
        window.Intercom("update", {
          email: getSessionStorage("userEmail"),
          name: getSessionStorage("fullName"),
          user_hash: hash,
          calendar_synced: true,
        });
      }
    }
    if (!accessToken && campaignMaxCallsAllowedToGetAccessToken > 0) {
      //console.log(`Access Token not found, Trying again!`);
      if (window.Intercom) {
        window.Intercom("update", {
          email: getSessionStorage("userEmail"),
          name: getSessionStorage("fullName"),
          user_hash: hash,
          calendar_synced: false,
        });
      }
      // setTimeout(getAccessToken, 1000);
      return;
    }
    // setuserCompanyName(userInfo?.companyName);
    // setuserCompanyAddress(userInfo?.companyAddress);
    // setuserDocumentId(userInfo?._id);
    // setuserPhoneNumber(userInfo?.phone);

    const calendarToken = await cronofyApi.getElementToken({
      sub: accessToken?.sub,
      permissions: ["account_management"],
      origin: subUserStatus ? [whiteLabelDomain, cronofy.redirect_uri] : cronofy.redirect_uri,
    });
    if (calendarToken) {
      ////console.log("inside if calendarToken -->", calendarToken);
      setCalendarOptions((prev) => ({
        ...prev,
        element_token: calendarToken.element_token.token,
        target_id: "cronofy-calendar-sync",
      }));
      // setCalendarToken(calendarToken.element_token.token);
    }

    const availabilityToken = await cronofyApi.getElementToken({
      sub: accessToken?.sub,
      permissions: ["managed_availability"],
      origin: subUserStatus ? [whiteLabelDomain, cronofy.redirect_uri] : cronofy.redirect_uri,
    });
    if (availabilityToken) {
      ////console.log("inside if availabilityToken -->", calendarToken);
      setAvailabilityOptions((prev) => ({
        ...prev,
        target_id: "cronofy-availability-rules",
        element_token: availabilityToken.element_token.token,
      }));
      // setAvailabilityToken(availabilityToken.element_token.token);
    }

    // //console.log(
    //   "calender token, availibility token",
    //   calendarToken,
    //   availabilityToken
    // );
  };

  // get calendar link data
  useEffect(() => {
    // if(!openCalenderDialog)return
    // if(openCalenderDialog){

    campaignMaxCallsAllowedToGetAccessToken = 5;
    // //console.log(
    //   `1122 Getting the Element token using sub from Access token`,
    //   accessToken,
    //   location?.state?.extra
    // );

    // if(location?.state){
    //   getAccessTokenExtra(_id)
    // }else{
    getAccessToken(_id);
    // }

    // getAccessToken({ accessToken: accessToken ? accessToken : location?.state?.extra });
    // }
  }, [accessToken, _id]);

  const handleConferencingLink = async (accessTokenCur) => {
    // //console.log(
    //   " called handleConferencingLink -->",
    //   accessTokenCur,
    //   accessToken
    // );
    if (!accessTokenCur) {
      accessTokenCur = accessToken;
    }
    const conferencingService = await cronofyApi.conferencingByCampaign({
      token: accessTokenCur?.access_token,
      redirect_uri: `${redirect_uri}&campaign_id=${_id}&title=${title}`,
      email: getSessionStorage("userEmail"),
      profile_email: accessTokenCur?.linking_profile.profile_name,
      campaign_id: _id,
    });
    // //console.log(" called conferencingService -->", conferencingService);

    if (conferencingService.linked) {
      return;
    }
    if (conferencingService.url) {
      setDialogState({ open: true, loadUrl: conferencingService?.url });
    }
  };
  const openUrl = () => {
    // //console.log("1122 open called -->", dialogState.loadUrl);
    window.open(`${dialogState.loadUrl}`, "_self", "noopener,noreferrer");
    setDialogState({ open: false, loadUrl: "" });
  };

  return (
    <>
      <Dialog
        open={dialogState?.open}
        onClose={(event, reason) => {
          if (
            reason &&
            (reason === "backdropClick" || reason === "escapeKeyDown")
          ) {
            return;
          }
          setDialogState({ open: false, loadUrl: "" });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Choose the Default Meeting Platform."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Conference services are not linked to the connected calendar. Please
            click on "Authorize" to establish a connection with your default
            meeting scheduling platform.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button onClick={openUrl} autoFocus>
            Authorize
          </Button>
        </DialogActions>
      </Dialog>

      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
            marginBottom: "10px",
            fontSize: "16px",
          }}
        >
          <LuCalendarPlus
            style={{
              marginRight: "10px",
              fontSize: "22px",
              color: theme.palette.primary.main,
            }}
          />
          {title}
        </Box>
        <Divider />
      </DialogTitle>
      <DialogContent>
        <Card sx={{ marginY: "10px" }} className="glass-wrapper-25">
          <CardContent>
            <div
              id="section7"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "15px",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <>
                  <LuCalendarPlus
                    style={{
                      fontSize: "22px",
                      color: theme.palette.primary.main,
                    }}
                  />
                </>
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Link calendar
                </Typography>
                {!conferencingLinked.linked && (
                  <Chip
                    size="small"
                    color="error"
                    label="Link meeting platform"
                    onClick={() => {
                      handleConferencingLink(conferencingLinked.accessToken);
                    }}
                    icon={<LinkIcon2 style={{ color: "white" }} />}
                  />
                )}
              </div>
              <Divider />
              <div style={{ marginTop: "20px" }}>
                <CalendarSyncWrapper
                  options={calendarOptions}
                  email={user.email}
                />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="glass-wrapper-25">
          <CardContent>
            {Boolean(availabilityElements.length) && (
              <div
                ref={section8Ref}
                id="section8"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginBottom: "15px",
                  }}
                >
                  <>
                    <MdOutlineWatchLater
                      style={{
                        marginRight: "10px",
                        fontSize: "24px",
                        color: theme.palette.primary.main,
                      }}
                    />
                  </>
                  <Typography
                    sx={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: theme.palette.text.primary
                    }}
                  >
                    {/* Select Your Availability */}
                    Set Working Hours / Availability
                  </Typography>
                </div>
                <Divider />
                <div id="availability-grid" style={{ marginTop: "20px" }}>
                  {availabilityElements.map((element) => element)}
                </div>
              </div>
            )}
            <CampaignSlotPresetSetting campaignId={_id} />
          </CardContent>
        </Card>
      </DialogContent>
    </>
  );
};

const SlotPresetSetting = () => {
  const [duration, setDuration] = useState(30);
  const checkFirstRender = useRef(true);
  const [buffer, setBuffer] = useState({
    isSetBuffer: false,
    before: 0,
    after: 0,
  });
  const [minimumNoticeTime, setMinimumNoticeTime] = useState(null);
  const [minimumNotice, setMinimumNotice] = useState(null);
  const [scheduleTime, setScheduleTime] = useState(null);
  const [dateOption, setDateOption] = useState(null);
  const [scheduleVisibility, setScheduleVisibility] = useState("");
  const [scheduleDate, setScheduleDate] = useState(null);
  const email = getSessionStorage("userEmail");
  const theme = useTheme();
  const handleDurationChange = async (event) => {
    const targetValue = event.target.value;
    setDuration(targetValue);
    updatedurationTime(targetValue);
  };

  const durationTime = async () => {
    /*const userSlotPreset = await fetch1(
      `${API_SERVICE_BACKEND_3}/get-slot-preset/${email}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );*/
    const userSlotPreset = await axios.get(
      `${API_SERVICE_BACKEND_3}/get-slot-preset/${email}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const duration = userSlotPreset.data;
    setDuration(duration?.data?.slotsPreset);
    let scheduleVisible = duration?.data?.schedulingOption
      ? duration?.data?.schedulingOption
      : "rolling";
    setScheduleVisibility(scheduleVisible);
    if (duration?.data?.schedulingOption === "rolling") {
      setScheduleTime(duration?.data?.rollingTime.split(" ")[0]);
      setDateOption(duration?.data?.rollingTime.split(" ")[1]);
    } else if (duration?.data?.schedulingOption === "custom") {
      let maxScheduleDate = new Date(duration?.data?.maximumSchedulingTime);
      maxScheduleDate.setDate(maxScheduleDate.getDate() - 1);
      setScheduleDate(maxScheduleDate);
    }
    if (duration.data.timeZone) {
      setTimezones(duration.data.timeZone);
    } else {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await handleTimeZoneChange(null, timeZone, false);
    }

    if (duration?.data?.buffer) {
      setBuffer(duration?.data?.buffer);
    }
    let minimumNoticeDate = duration?.data?.minimumNotice;
    if (minimumNoticeDate && new Date(minimumNoticeDate) > new Date()) {
      let minimumNoticeTime = new Date(duration?.data?.minimumNotice);
      setMinimumNoticeTime(formatDate(minimumNoticeTime));
      let diff = new Date(minimumNoticeDate) - new Date();
      setMinimumNotice(Math.ceil(diff / 1000 / 60 / 60));
    }
  };

  // //console.log(
  //   "Intl.DateTimeFormat().resolvedOptions().timeZone",
  //   Intl.DateTimeFormat().resolvedOptions().timeZone
  // );
  useEffect(() => {
    durationTime();
  }, []);

  const updatedurationTime = async (targetValue) => {
    /*const res = await fetch1(
      `${API_SERVICE_BACKEND_3}/updateUserSlotPreset/${email}/${targetValue}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );*/
    const res = await axios(
      {
        method: "PUT",
        url: `${API_SERVICE_BACKEND_3}/updateUserSlotPreset/${email}/${targetValue}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    if (res.status === 200) {
      toast.success("Slot Preset Updated Successfully");
    } else {
      toast.error("Error Updating Slot Preset");
    }
  };

  useEffect(() => {
    if (checkFirstRender.current) {
      checkFirstRender.current = false;
      return;
    }
  }, [duration]);

  const handleBufferChange = (event) => {
    const { name, value } = event.target;
    setBuffer((prevState) => ({
      ...prevState,
      [name]: Number(value),
    }));
  };

  const handleBufferVisibilityChange = async (event) => {
    setBuffer((prevState) => ({
      ...prevState,
      isSetBuffer: !buffer.isSetBuffer,
    }));

    if (event.target.value === "false") {
      const res = await updateSlotPreset(false);
      if (res.status === 200) {
        toast.success("Buffer Updated Successfully");
      } else {
        toast.error("Error Updating Buffer");
      }
    }
  };

  const updateSlotPreset = async (isSetBuffer) => {
    ////console.log("12 GLOBAL -->", isSetBuffer);
    /*return await fetch1(
      `${API_SERVICE_BACKEND_3}/updateUserSlotPreset/${email}/${duration}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...buffer,
          isSetBuffer: isSetBuffer ?? buffer.isSetBuffer,
        }),
      }
    );*/
    return await axios.put(
      `${API_SERVICE_BACKEND_3}/updateUserSlotPreset/${email}/${duration}`,
      {
        ...buffer,
        isSetBuffer: isSetBuffer ?? buffer.isSetBuffer,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  };

  const handleSaveBuffer = () => {
    (async () => {
      const res = await updateSlotPreset();
      if (res.status === 200) {
        toast.success("Buffer Updated Successfully");
      } else {
        toast.error("Error Updating Buffer");
      }
    })();
  };

  const [timezones, setTimezones] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const handleTimeZoneChange = async (event, value, msg) => {
    try {
      if (msg === "clear") {
        return;
      }
      const res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateUserTimeZone/${email}`,
        {
          timeZone: value || Intl.DateTimeFormat().resolvedOptions().timeZone,
        }
      );

      if (res.status === 200) {
        setTimezones(res.data.data.timeZone);
        if (msg !== false) {
          toast.success("Time Zone updated successfully!!");
        }
      }
    } catch (e) {
      //console.log("err --->", e);
    }
  };

  const handleMinimumNotice = async () => {
    if (!minimumNotice) {
      toast.error("Please enter minimum notice time");
      return;
    }
    let minimum_notice = new Date();
    minimum_notice.setHours(minimum_notice.getHours() + minimumNotice);
    minimum_notice = moment(minimum_notice)
      .tz(timezones)
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    if (minimumNotice === 0) {
      minimum_notice = null;
    }
    const res = await axios.post(
      `${API_SERVICE_BACKEND_3}/updateUserMinimumNotice/${email}`,
      {
        minimum_notice,
      }
    );
    if (res.status === 200) {
      let currentDate = moment(new Date())
        .tz(timezones)
        .format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (minimum_notice && new Date(minimum_notice) > new Date(currentDate)) {
        setMinimumNoticeTime(formatDate(new Date(minimum_notice)));
        let diff = new Date(minimum_notice) - new Date(currentDate);
        setMinimumNotice(Math.ceil(diff / 1000 / 60 / 60));
      }
      toast.success("Minimum Notice updated successfully!!");
    } else {
      toast.error("Error Updating Minimum Notice Time");
    }
  };
  const removeMinimumNotice = async () => {
    const res = await axios.post(
      `${API_SERVICE_BACKEND_3}/updateUserMinimumNotice/${email}`,
      { minimum_notice: null }
    );
    if (res.status === 200) {
      setMinimumNotice("");
      setMinimumNoticeTime(null);
      toast.success("Minimum Notice removed successfully!!");
    } else {
      toast.error("Error Removing Minimum Notice Time");
    }
  };
  const handleMaxScheduleTime = async () => {
    if (!scheduleVisibility) {
      toast.error("Please select the above options");
      return;
    }
    let res;
    if (scheduleVisibility === "rolling") {
      if (!scheduleTime || !dateOption) {
        toast.error("Please select the rolling period");
        return;
      }
      res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateUserMaximumSchedulingTime/${email}`,
        {
          scheduleTime: parseInt(scheduleTime),
          dateOption: dateOption,
          option: scheduleVisibility,
        }
      );
      if (res.status === 200) {
        setScheduleTime(parseInt(scheduleTime));
        setScheduleDate(null);
        toast.success("Maximum Scheduling Time updated successfully!!");
      } else {
        toast.error("Error Updating Maximum Scheduling Time");
      }
    } else {
      if (!scheduleDate) {
        toast.error("Please select the date");
        return;
      }
      res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateUserMaximumSchedulingTime/${email}`,
        {
          scheduleDate: scheduleDate,
          option: scheduleVisibility,
        }
      );
      if (res.status === 200) {
        setScheduleDate(scheduleDate);
        setScheduleTime("");
        toast.success("Maximum Scheduling Time updated successfully!!");
      } else {
        toast.error("Error Updating Maximum Scheduling Time");
      }
    }
  };
  const removeMaxScheduleTime = async () => {
    if (scheduleVisibility === "rolling") {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateUserMaximumSchedulingTime/${email}`,
        {
          scheduleTime: null,
          dateOption: null,
          option: null,
        }
      );
      if (res.status === 200) {
        setScheduleTime("");
        setDateOption(null);
        toast.success("Maximum Scheduling Time removed successfully!!");
      } else {
        toast.error("Error Removing Maximum Scheduling Time");
      }
    } else {
      const res = await axios.post(
        `${API_SERVICE_BACKEND_3}/updateUserMaximumSchedulingTime/${email}`,
        {
          scheduleDate: null,
          option: null,
        }
      );
      if (res.status === 200) {
        setScheduleDate(null);
        toast.success("Maximum Scheduling Time removed successfully!!");
      } else {
        toast.error("Error Removing Maximum Scheduling Time");
      }
    }
  };
  const dateOptions = ["Day", "Week", "Month"];

  const handleSchedulingDate = async (event, value) => {
    setDateOption(value);
  };

  const handleScheduleVisibility = async (event) => {
    setScheduleVisibility(event.target.value);
  };

  const handleSchedulingCalendar = async (event) => {
    setScheduleDate(event);
  };

  const CustomPopper = styled(Popper)(({ theme }) => ({
    "& .MuiAutocomplete-listbox": {
      fontSize: "14px",
    },
  }));

  return (
    <>
      <Divider />

      <Grid item xs={12}>
        <InputLabel
          sx={{
            // ml: 3,
            mt: 3,
            fontFamily: "Inter",
            // fontSize: "14px",
            // fontWeight: 500,
            lineHeight: "20px",
            // color: "#55597A",
            mb: "6px",

            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}

        >
          Timezone
        </InputLabel>{" "}
        <Autocomplete
          options={option}
          sx={{ width: { xs: "80%", md: "95%" } }}
          id="auto-highlight"
          PopperComponent={CustomPopper}
          autoHighlight
          renderInput={(params) => (
            <TextField {...params} variant={"outlined"} />
          )}
          onChange={handleTimeZoneChange}
          value={timezones}
          className="glass-input"
        />
      </Grid>

      <Divider sx={{ marginY: "10px" }} />

      <FormLabel
        component="legend"
        sx={{
          fontSize: "16px",
          color: theme.palette.text.primary,
          fontWeight: 600,
        }}
      >
        Meeting Duration
      </FormLabel>
      <RadioGroup
        onChange={handleDurationChange}
        row
        aria-label="duration"
        name="duration"
        value={duration}
        style={{ fontSize: '14px' }}
      >
        <FormControlLabel
          value={15}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>15 Minutes</Typography>
          }
        />
        <FormControlLabel
          value={30}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>30 Minutes</Typography>
          }
        />
        <FormControlLabel
          value={60}
          control={<Radio />}
          label={
            <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>60 Minutes</Typography>
          }
        />
      </RadioGroup>

      <Divider sx={{ marginY: "10px" }} />

      <Grid
        item
        container
        direction="row"
        gap={2}
        alignItems={"center"}
        marginTop={"10px"}
      >
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Buffer Time:
        </Typography>

        <RadioGroup
          onChange={handleBufferVisibilityChange}
          row
          aria-label="buffer"
          value={buffer.isSetBuffer}
          name={"isSetBuffer"}
        >
          <FormControlLabel
            value={false}
            control={<Radio />}
            label={<Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>No</Typography>}
          />
          <FormControlLabel
            value={true}
            control={<Radio />}
            label={<Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>Yes</Typography>}
          />
        </RadioGroup>
      </Grid>

      {buffer && buffer.isSetBuffer && (
        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item container direction="row" gap={2}>
            <Grid item container alignItems="center" columnSpacing={1}>
              <Typography sx={{ marginRight: "8px", fontSize: "14px", color: theme.palette.text.primary }}>
                before :{" "}
              </Typography>
              <TextField
                name={"before"}
                value={buffer?.before}
                variant="outlined"
                size="small"
                type="number"
                max={60}
                error={buffer?.before > 60}
                helperText={
                  buffer?.before > 60 && "maximum buffer time should be 60"
                }
                sx={{ flexGrow: 1, fontSize: "14px" }}
                inputProps={{ min: 0 }}
                onChange={handleBufferChange}
                className="glass-input"
              />
            </Grid>

            <Grid item container alignItems="center" columnSpacing={1}>
              <Typography sx={{ marginRight: "8px", fontSize: "14px", color: theme.palette.text.primary }}>
                after :{" "}
              </Typography>
              <TextField
                name={"after"}
                value={buffer?.after}
                variant="outlined"
                size="small"
                type="number"
                max={60}
                error={buffer?.after > 60}
                helperText={
                  buffer?.after > 60 && "maximum buffer time should be 60"
                }
                sx={{ flexGrow: 1, fontSize: "14px" }}
                inputProps={{ min: 0 }}
                onChange={handleBufferChange}
                className="glass-input"
              />
            </Grid>

            <Grid item container alignItems="center" columnSpacing={1}>
              <Button
                sx={{ marginRight: "8px", fontSize: "14px" }}
                disabled={buffer?.after > 60 || buffer?.before > 60}
                variant={"outlined"}
                size={"small"}
                onClick={handleSaveBuffer}
                className="glass-button-secondary-50"
              >
                Save Buffer{" "}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Divider sx={{ marginY: "10px" }} />
      <Grid item container gap={2} direction="column" marginTop={"10px"}>
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Maximum Scheduling Time
        </Typography>
        <RadioGroup
          onChange={handleScheduleVisibility}
          row
          aria-label="Schedule Time"
          value={scheduleVisibility}
          name="radio-buttons-group"
        >
          <FormControlLabel
            value="rolling"
            control={<Radio />}
            label={
              <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>
                Over a period of rolling time
              </Typography>
            }
          />
          <FormControlLabel
            value="custom"
            control={<Radio />}
            label={
              <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>Custom date</Typography>
            }
          />
        </RadioGroup>
        {scheduleVisibility === "rolling" ? (
          <Grid container alignItems="center" columnSpacing={2}>
            <Grid item container direction="row" gap={2}>
              <Grid item container alignItems="center" columnSpacing={1}>
                <TextField
                  placeholder="Enter Period"
                  value={scheduleTime}
                  variant="outlined"
                  id="outlined-basic"
                  size="small"
                  type="number"
                  sx={{ flexGrow: 1 }}
                  className="glass-input"
                  inputProps={{ min: 1 }}
                  onChange={(e) => setScheduleTime(parseInt(e.target.value))}
                />
              </Grid>

              <Autocomplete
                options={dateOptions}
                sx={{ width: "50%" }}
                // className="glass-input"
                size="small"
                variant="outlined"
                id="outlined-basic"
                className="glass-input"
                PopperComponent={CustomPopper}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant={"outlined"}
                    placeholder="Select"
                  />
                )}
                onChange={handleSchedulingDate}
                value={dateOption}
              />
              <Grid item container alignItems="center" columnSpacing={2}>
                <Button
                  sx={{ marginRight: "8px" }}
                  variant={"outlined"}
                  size={"small"}
                  onClick={handleMaxScheduleTime}
                  className="glass-button-secondary-50"
                >
                  Set
                </Button>
                <Button
                  sx={{ marginRight: "8px" }}
                  variant={"outlined"}
                  size={"small"}
                  onClick={removeMaxScheduleTime}
                  className="glass-button-secondary-50"
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Grid>
            <Grid item container alignItems="center" direction="row" gap="2">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Max Date"
                  disablePast
                  value={scheduleDate}
                  onChange={handleSchedulingCalendar}
                  renderInput={(params) => <TextField {...params} />}
                  className="glass-input"
                  PaperProps={{ className: "glass-popup" }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item container alignItems="center" marginTop={2}>
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={handleMaxScheduleTime}
                className="glass-button-secondary-50"
              >
                Set
              </Button>
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={removeMaxScheduleTime}
                className="glass-button-secondary-50"
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
      <Divider sx={{ marginY: "10px" }} />
      <Grid item container gap={2} direction="column" marginTop={"10px"}>
        <Typography
          sx={{
            fontSize: "16px",
            color: theme.palette.text.primary,
            fontWeight: 600,
          }}
        >
          Minimum Notice Time
        </Typography>

        <Grid container alignItems="center" columnSpacing={2}>
          <Grid item container direction="row" gap={1}>
            <Grid item container alignItems="center" columnSpacing={1}>
              <TextField
                placeholder="In Hours"
                value={minimumNotice === null ? "" : minimumNotice}
                variant="outlined"
                id="outlined-basic"
                size="small"
                type="number"
                sx={{ flexGrow: 1 }}
                className="glass-input"
                inputProps={{ min: 0 }}
                onChange={(e) => setMinimumNotice(parseInt(e.target.value))}
              />
            </Grid>

            <Grid item container alignItems="center">
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size="small"
                onClick={handleMinimumNotice}
                className="glass-button-secondary-50"
              >
                Set
              </Button>
            </Grid>
            <Grid item container alignItems="center">
              <Button
                sx={{ marginRight: "8px" }}
                variant={"outlined"}
                size={"small"}
                onClick={removeMinimumNotice}
                className="glass-button-secondary-50"
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Grid>
        {minimumNoticeTime && (
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: theme.palette.text.primary
            }}
          >
            Valid till{" "}
            <span style={{ color: "red", fontWeight: 400 }}>
              {minimumNoticeTime}
            </span>
          </Typography>
        )}
      </Grid>
    </>
  );
};

// Time zone 
const TimeZoneComponent = ({
  handleTimeZoneChange,
  timezones,
  selectedCountry
}) => {
  return (<Grid item xs={12}>
    <Autocomplete
      value={selectedCountry ?? ""}
      inputValue={selectedCountry?.label || ''}
      id="email-dropdown"
      options={timezones}
      onInputChange={(event, newInputValue) => {
        // Update the input value for search
        handleTimeZoneChange({ label: newInputValue });
      }}
      onChange={(event, newValue) => {
        handleTimeZoneChange(newValue);
      }}
      getOptionLabel={(option) => option?.label ?? ""}
      sx={{
        mt: 1,
        "& .MuiFilledInput-root": {
          gap: "5px",
          pt: "30px",
        },
      }}
      renderOption={(props, option) => {

        return (
          <li {...props}>
            <Grid width="100%" display="flex" justifyContent="space-between" alignItems="center">
              <Grid item xs={9} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {option?.label}
              </Grid>
            </Grid>
          </li>
        );
      }}

      renderInput={(params) => {
        const [zoneLabel, time] = selectedCountry?.label?.split(' - ') || [];

        return (
          <TextField
            {...params}
            label="Timezone"
            variant="outlined"
            className="glass-input"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Grid item xs={3} style={{ marginRight: '-40px', fontSize: '14px', textAlign: 'right', fontWeight: 500 }}>
                  {time ? `Current: ${time}` : ''}
                </Grid>
              ),
            }}
            inputProps={{
              ...params.inputProps,
              value: zoneLabel || '', // only show zone in main input
            }}
          />
        );
      }}

    />
  </Grid>)
}
export const AccountGeneralSettings = (props) => {
  const location = useLocation();
  const { user } = useAuth();
  const userInfo = useUserDetail();
  //const [isNewInterfaceEnabled, setIsNewInterfaceEnabled] = useState(userInfo?.isNewInterfaceEnabled || false);
  const {
  isNewInterfaceEnabled,
  setIsNewInterfaceEnabled,
} = useContext(SettingsContext);
  const [openCalenderDialog, setOpenCalenderDialog] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [activeSubTab, setActiveSubTab] = useState(0);
  const query = new URLSearchParams(location.search);
  const queryParams = {};
  query.forEach((value, key) => (queryParams[key] = value));
  const navigate = useNavigate();
  const { stateLocation } = location;
  const openModal = stateLocation?.openModal;
  const { code, from, campaign_id, title, state } = queryParams;
  const [isLoading, setIsLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceTotal, setInvoiceTotal] = useState();
  const [invoicePage, setInvoicePage] = useState(1);
  const [invoiceLimit, setInvoiceLimit] = useState(5);
  const [hasMore, setHasMore] = useState(false);
  const [invoicePagesCache, setInvoicePagesCache] = useState({}); // { [pageNumber]: { data, first, last } }
  const [currentSubscription, setCurrentSubscription] = useState('');
  const [resetDate, setResetDate] = useState(null);
  const userEmail = getSessionStorage("userEmail");

  const [firstInvoiceId, setFirstInvoiceId] = useState(null);
  const [lastInvoiceId, setLastInvoiceId] = useState(null);


  useEffect(() => {
    const getCredits = async () => {
      try {
        const response = await axios.get(`${API_SERVICE_CREDITS}/credits/?email=${encodeURIComponent(userEmail)}`);
        const data = response.data;
        setResetDate(data?.resetsAt);
      } catch (err) {
        console.error("Error fetching credits:", err);
      }
    };
    getCredits();
  }, [userEmail]);


  const subscriptionDetails = {
    startDate: userInfo?.userSubscription?.subscriptions?.base?.startDate
      ? new Date(
        userInfo?.userSubscription?.subscriptions?.base?.startDate
      )?.toDateString()
      : null,
    endDate: userInfo?.userSubscription?.subscriptions?.base?.endDate
      ? new Date(
        userInfo?.userSubscription?.subscriptions?.base?.endDate
      )?.toDateString()
      : null,
    resetsAt: resetDate ? new Date(resetDate)?.toDateString() : null,
    isFreeSubscription:
      userInfo?.userSubscription?.subscriptions?.base?.planId === 'free',
  };

  useEffect(() => {
    if (state) {
      const myState = JSON.parse(state);
      navigate(
        `${location.pathname}?from=cronofy&code=${code}&campaign_id=${myState.campaign_id}&title=${myState.title}`,
        {
          replace: true,
          preventScrollReset: true,
        }
      );
    }
  }, [state]);
  
  const handleCalenderDialogClose = () => {
    setOpenCalenderDialog(false);
    navigate(location.pathname, { replace: true, preventScrollReset: true });
  };
  useEffect(() => {
    if (campaign_id) {
      setOpenCalenderDialog(true);
    }
  }, [campaign_id]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const from = searchParams.get("from");
    const lastLinkedProfileId = searchParams.get("last_linked_profile_id");
    const campaign_id = searchParams.get("campaign_id");

    if (from === "cronofy" && lastLinkedProfileId) {
      makeApiCall(from, lastLinkedProfileId, campaign_id);
    }
  }, [location.search]);

  const makeApiCall = (from, lastLinkedProfileId, campaign_id) => {
    if (campaign_id) {
      cronofyApi.conferencingLinkedByCampaign({ campaign_id: campaign_id });
    } else {
      cronofyApi.conferencingLinked({ email: email });
    }
  };

  const section1Ref = useRef();
  const section2Ref = useRef();
  const section3Ref = useRef();
  const section4Ref = useRef();
  const section5Ref = useRef();
  const section6Ref = useRef();
  const section7Ref = useRef();
  const section8Ref = useRef();
  const section9Ref = useRef();
  const section10Ref = useRef();
  const section11Ref = useRef();
  const section12Ref = useRef();
  const section13Ref = useRef();
  const section14Ref = useRef();
  const section15Ref = useRef();
  const section16Ref = useRef();
  const section17Ref = useRef();

  const userType = user?.dbRef?.userType;
  const isOwnWorkspace = getSessionStorage("isOwnWorkspace");
  const hideAccountDetails = isOwnWorkspace !== null && isOwnWorkspace === "false";

  let navHeader = [
    ...(hideAccountDetails ? [] : [{
      headerTitle: "Account Details",
      headerRef: section1Ref,
      headerID: "section1",
      tabId: "accountdetails",
    }]),
    {
      headerTitle: "Usage & Features",
      headerRef: section16Ref,
      headerID: "section16",
      tabId: "credits",
    },
    // {
    //   headerTitle: "Sending Accounts",
    //   headerRef: section11Ref,
    //   headerID: "section11",
    //   tabId: "sendingaccounts",
    // },
    // {
    //   headerTitle: "Purchase Plans",
    //   headerRef: section5Ref,
    //   headerID: "section5",
    //   tabId: "subscriptiondetails",
    // },
    {
      headerTitle: "Manage Users",
      headerRef: section13Ref,
      headerID: "section13",
      tabId: "inviteteammembers",
    },
    // {
    //   headerTitle: "Meetings Available Slots",
    //   headerRef: section5Ref,
    //   headerID: "section5",
    // },
    // {
    //   headerTitle: "Meeting Link",
    //   headerRef: section6Ref,
    //   headerID: "section6",
    // },
    {
      headerTitle: "Calendars",
      headerRef: section7Ref,
      headerID: "section7",
      tabId: "calendars",
    },
    // {
    //   headerTitle: "Global Calendar",
    //   headerRef: section7Ref,
    //   headerID: "section7",
    //   tabId: "globalcalendar"
    // },
    // {
    //   headerTitle: "AI Agent Calendars",
    //   headerRef: section10Ref,
    //   headerID: "section10",
    //   tabId: "aiagentcalendars"
    // },
    {
      headerTitle: "Integrations",
      headerRef: section9Ref,
      headerID: "section9",
      tabId: "integrations",
    },
    // {
    //   headerTitle: "Manage Duplicates",
    //   headerRef: section12Ref,
    //   headerID: "section12",
    //   tabId: "manageduplicates",
    // },
    {
      headerTitle: "Block List",
      headerRef: section14Ref,
      headerID: "section14",
      tabId: "blocklist",
    },
    // {
    //   headerTitle: "AI BDR",
    //   headerRef: section17Ref,
    //   headerID: "section17",
    //   tabId: "aibdr",
    // },
  ];

  // if (isFreeSubscriptionUser) {
  //   navHeader = navHeader.filter(
  //     (ele) => ele.headerTitle != "Subscription Details"
  //   );
  // }

  if (userType !== "enterprise") {
    navHeader = navHeader.filter(
      (ele) => ele.headerTitle != "Sending Accounts"
    );
  }

  useEffect(() => {
    const query = new URLSearchParams(location?.search);
    const tab = query?.get("tab");
    let isValid = true;
    if (tab) {
      if (userType !== "enterprise") {
        if (tab === "sendingaccounts") {
          isValid = false;
        }
      }
      // No special restriction for sub-users; allow accountdetails selection
      if (isValid) {
        const filteredTab = navHeader?.find((header) => header.tabId === tab);
        if (filteredTab?.headerID) {
          setActiveMenuItem(filteredTab?.headerID);
        }
      }
    } else {
      // No tab provided in URL; default to the first tab in navHeader
      if (navHeader && navHeader.length) {
        setActiveMenuItem(navHeader[0].headerID);
      } else {
        setActiveMenuItem("section1");
      }
    }
  }, [location.search, navHeader]);
  //function to handle change in phone number
  const handleChange = (newValue) => setuserPhoneNumber(newValue);

  const [prevPassword, setPrevPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordError, setPasswordError] = useState(null);

  const [dates, setDates] = useState([]);
  const dispatch = useDispatch();
  // //console.log("prevPassword: ", prevPassword);

  useEffect(() => {
    const date = [];
    // Calculate the list of dates starting from tomorrow and spanning the next 7 days
    const startDate = moment().add(1, "days"); // Start from tomorrow
    for (let i = 0; i < 5; i++) {
      date.push(startDate.format("YYYY-MM-DD"));
      startDate.add(1, "days");
    }
    setDates(date);
    // Set the list of dates as options for the Select component
    setuserMeetingDate(dates[0]); // Set the default selected date to the first one
  }, []);

  const isStrongPassword = (password) => {
    if (password.length < 8) {
      return "Password must be at least 8 characters long.";
    }

    // Password should contain at least one uppercase letter
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter.";
    }

    // Password should contain at least one lowercase letter
    if (!/[a-z]/.test(password)) {
      return "Password must contain at least one lowercase letter.";
    }

    // Password should contain at least one digit
    if (!/\d/.test(password)) {
      return "Password must contain at least one digit.";
    }

    // Password should contain at least one special character
    if (!/[@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/.test(password)) {
      return "Password must contain at least one special character.";
    }

    // If all conditions are met, the password is considered strong
    return true;
  };

  const handlePasswordChange = (e) => {
    const newPasswordValue = e.target.value;
    setNewPassword(newPasswordValue);

    // Check the strength of the password and update the error message
    const passwordStrengthError = isStrongPassword(newPasswordValue);
    setPasswordError(passwordStrengthError);
  };

  const handlePasswordUpdate = async () => {
    if (newPassword === "" || prevPassword === "") {
      toast.error("Invalid Password!!");
      return;
    }

    const passwordStrengthError = isStrongPassword(newPassword);
    if (passwordStrengthError !== true) {
      toast.error(passwordStrengthError);
      setPasswordError(passwordStrengthError);
      return;
    }

    // Clear any previous password error
    setPasswordError(null);

    const auth = getAuth();
    const user = auth.currentUser;

    // Re-authenticating the user with their current credentials
    const credential = EmailAuthProvider.credential(user.email, prevPassword);

    await reauthenticateWithCredential(user, credential)
      .then((res) => {
        // User successfully re-authenticated
        updatePassword(user, newPassword)
          .then(() => {
            toast.success("Password updated successfully");
            setPrevPassword(newPassword);
          })
          .catch((error) => {
            toast.error("Error updating password:", error.message);
          });
      })
      .catch((error) => {
        // //console.log("error: ", error.message);
        if (error.message.includes("wrong-password")) {
          return toast.error("Please enter valid password");
        }
        toast.error("Please Re-login");
      });
  };

  const {
    showAlert,
    avatar,
    email,
    name,
    element_tokens,
    cronofy_options,
    userCompanyName,
    setuserCompanyName,
    setuserCompanyAddress,
    userCompanyAddress,
    userCompanyLogo,
    setuserPhoneNumber,
    userPhoneNumber,
    setuserMeetingDate,
    userFirstName,
    userLastName,
    userTimezone,
    setUserFirstName,
    setUserLastName,
    conferencingLinked,
    handleConferencingLink,
    infoUser,
    getAccessToken,
    setUserTimezone
  } = props;
  // Open Integrations immediately when OAuth returns (?tab=integrations&...) so callback UI runs on first paint
  const [activeMenuItem, setActiveMenuItem] = useState(() => {
    if (typeof window === "undefined") return "section1";
    const tab = new URLSearchParams(window.location.search).get("tab");
    return tab === "integrations" ? "section9" : "section1";
  });
  const [uploadingProfileImage, setUploadingProfileImage] = useState(false);
  const [updatedProfileImage, setUpdatedProfileImage] = useState("");

  const { redirect_uri } = cronofy_options;
  const { calendarToken, availabilityToken } = element_tokens;

  const [calendarOptions, setCalendarOptions] = useState({
    data_center: cronofy.data_center,
    target_id: "cronofy-calendar-sync",
    authorization: {
      redirect_uri,
      client_id: cronofy.client_id,
      scope: "read_write",
      avoid_linking: true,
    },
    styles: {
      prefix: "CalendarSync",
    },
  });

  useEffect(() => {
    if (!calendarToken) return;
    setCalendarOptions((prev) => ({
      ...prev,
      element_token: calendarToken,
      target_id: "cronofy-calendar-sync",
    }));
  }, [calendarToken, activeSubTab]);

  const [availabilityOptions, setAvailabilityOptions] = useState({
    target_id: "cronofy-availability-rules",
    data_center: cronofy.data_center,
    availability_rule_id: "work_hours",
    tzid: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  useEffect(() => {
    if (!availabilityToken) return;
    setAvailabilityOptions((prev) => ({
      ...prev,
      element_token: availabilityToken,
      target_id: "cronofy-availability-rules",
    }));
  }, [availabilityToken, activeSubTab]);

  const [availabilityElements, setAvailabilityElements] = useState([]);
  useEffect(() => {
    if (!availabilityOptions.element_token) return;
    setAvailabilityElements((prev) => [
      // ...prev,
      // ...prev,
      <AvailabilityRulesWrapper
        key="availability-rules"
        options={availabilityOptions}
      />,
    ]);
  }, [availabilityOptions, activeSubTab]);

  const saveAccessToken = async (paramsStr) => {
    const res = await axios.get(
      `${API_SERVICE_BACKEND_2}/saveZoho?${paramsStr}`,
      {
        params: {
          email: user.email,
        },
      }
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = new URLSearchParams(window.location.search);
      const status = params.get("i");
      const access_token = params.get("at");
      const refresh_token = params.get("rt");
      const type = params.get("t");
      const expires_at = params.get("ea");
      const account_server = params.get("act");
      const loc = params.get("loc");

      dispatch(thunks.setAccessToken(access_token));
      try {
        setSessionStorage("hubspot_access_token", access_token);
      } catch (error) {
        console.error("Error setting local storage:", error);
      }

      const getIntegration = (type)=>{
        switch(type){
          case "zoho":
            return "Zoho";
          case "hubspot":
            return "Hubspot";
          case "zapier":
            return "Zapier";
          case "pipedrive":
            return "Pipedrive";
          case "salesforce":
            return "Salesforce";
          default:
            return "Unknown";
        }

      }
      if (status === "s") {
        var dataSend = {
          userEmail: email,
          access_token,
          expires_at,
          refresh_token,
          type,
          account_server,
          location: loc,
        };

        /*const resDataLog = await fetch1(
          `${API_SERVICE_BACKEND_2}/addintegration`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataSend),
          }
        );*/
        const resDataLog = await axios.post(
          `${API_SERVICE_BACKEND_2}/addintegration`,
          dataSend,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (resDataLog.status === 200) {
          // Handle success
          // window.location.replace(location.pathname);
          // window.location.replace(`${location.pathname}?tab=integrations`);
          toast.success(`${getIntegration(type)} integration successful`);
          // toast.success("Hubspot integration successful");
        }
      }
    };

    // Call fetchData() inside the useEffect
    fetchData();
  }, [activeSubTab]);

  useEffect(() => {
    const isInViewport = (element) => {
      let rect = {};
      if (element) {
        rect = element.getBoundingClientRect();
      }
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
        (window.innerWidth || document.documentElement.clientWidth)
      );
    };
    const handleScroll = () => {
      if (isInViewport(section1Ref?.current)) {
        setActiveMenuItem("section1");
      } else if (isInViewport(section2Ref?.current)) {
        setActiveMenuItem("section2");
      } else if (isInViewport(section3Ref?.current)) {
        setActiveMenuItem("section3");
      } else if (isInViewport(section4Ref?.current)) {
        setActiveMenuItem("section4");
      }
      // else if (isInViewport(section5Ref?.current)) {
      //   setActiveMenuItem('section5');
      // }
      // else if (isInViewport(section6Ref?.current)) {
      //   setActiveMenuItem('section6');
      // }
      else if (isInViewport(section7Ref?.current)) {
        setActiveMenuItem("section7");
        setCalendarOptions((prev) => ({
          ...prev,
          target_id: "cronofy-calendar-sync",
        }));
      } else if (isInViewport(section8Ref?.current)) {
        setActiveMenuItem("section8");
      } else if (isInViewport(section9Ref?.current)) {
        setActiveMenuItem("section9");
      } else if (isInViewport(section10Ref?.current)) {
        setActiveMenuItem("section10");
      } else if (isInViewport(section11Ref?.current)) {
        setActiveMenuItem("section11");
      } else if (isInViewport(section12Ref?.current)) {
        setActiveMenuItem("section12");
      } else {
        setActiveMenuItem(null);
      }
    };
  }, []);

  const [customCampLimit, setCustomCampLimit] = useState(0);
  const [userCampaigns, setUserCampaigns] = useState([]);
  const [userCampaignLoading, setUserCampaignLoading] = useState(false);
  const organizationId = getSessionStorage("organization_id");
  const [emailInvites, setEmailInvites] = useState("");
  const [userData, setUserData] = useState([]);
  const [invite, setInvite] = useState(false);
  const [resend, setResend] = useState(false);
  const [selectedRole, setSelectedRole] = useState("MEMBER");
  const [isRoleUpdateOpen, setIsRoleUpdateOpen] = useState(false);
  const [selectedMemberForRoleUpdate, setSelectedMemberForRoleUpdate] = useState(null);
  const [updatingRole, setUpdatingRole] = useState(false);
  const theme = useTheme();

  const loadPolicyDetails = () => {
    try {
      axios
        .get(
          `${ADMIN_SERVER}/customer/getPolicyDetails/${user?.email}/${organizationId}`
        )
        .then((res) => {
          // //console.log(res);
          const agentCount = parseInt(res.data.policyControls["Agent Count"]);
          setCustomCampLimit(agentCount || 0);
        })
        .catch((error) => {
          // //console.log("error", error);
          return error;
        });
    } catch (e) { }
  };

  const loadUserCampaigns = () => {
    const fields = "_id, responsibility, title, companyName, extra, hubspotContactsOwner";
    try {
      setUserCampaignLoading(true);
      jobsApi
        .getUserCampaigns(user?.email, "", 0, 0, "all", "", "", fields)
        .then((data) => {
          setUserCampaigns(data?.data);
          setUserCampaignLoading(false);
          // setFilteredCampaigns(data);
        })
        .catch((error) => {
          // //console.log("error", error);
          // return error
        })
        .finally(() => {
          // setIsEmptyChartData(false);
          // setCampaignsLoading(false);
        });
    } catch (e) {
      // //console.log(e);
    }
  };

  useEffect(() => {
    loadPolicyDetails();
    loadUserCampaigns();
  }, [user]);

  const getUserDetails = async () => {
    await axios
      .get(
        `${API_SERVICE_BACKEND}/list-invite/${userInfo?.email ?? user?.email}`
      )
      .then((res) => {
        setUserData(res.data?.data);
      })
      .catch((err) => {
      });
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  // Poll for invite status updates so the Manage Users table stays in sync
  useEffect(() => {
    const interval = setInterval(() => {
      getUserDetails();
    }, 10000); // poll every 10 seconds

    return () => clearInterval(interval);
  }, []);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const isInviteAccepted = (status) => {
    const s = String(status || "").toLowerCase();
    return ["accept", "accepted", "active", "joined"].includes(s);
  };

  const isInvitePending = (status) => String(status || "").toLowerCase() === "pending";

  const handleInvite = async () => {
    try {
      const validEmail = validateEmail(emailInvites);
      if (!validEmail) {
        toastify.error("Invalid email!!");
        return;
      }
      const response = await axios.post(`${API_SERVICE_BACKEND}/user-invites`, {
        sender_mail: userInfo?.email ?? user?.email,
        receiver_mail: emailInvites,
        role: selectedRole || "MEMBER",
      });
      if (!response?.data?.status) {
        toastify.warn(response.data.message);
        setInvite(false);
        return;
      } else {
        toastify.success(response.data.message);
        setInvite(false);
        setEmailInvites("");
        setSelectedRole("MEMBER"); // Reset to default
        getUserDetails();
      }
    } catch (error) {
      toastify.error(error?.response?.data?.message);
      setInvite(false);
    }
  };

  const handleResend = async (toEmail, companyName, existingRole) => {
    try {
      const validEmail = validateEmail(toEmail);
      if (!validEmail) {
        toastify.error("Invalid email!!");
        return;
      }
      setResend(true);
      toastify.info("Kindly wait for a few seconds");
      setTimeout(async () => {
        const response = await axios.post(
          `${API_SERVICE_BACKEND}/user-invites`,
          {
            sender_mail: userInfo?.email ?? user?.email,
            receiver_mail: toEmail,
            sendEmailOnly: true,
            companyName: companyName ?? "",
            role: existingRole || "MEMBER",
          }
        );
        // //console.log("response check==>", response.data.message);
        if (!response?.data?.status) {
          setResend(false);
          toastify.warn(response.data.message);
          return;
        } else {
          toastify.success(response.data.message);
          setResend(false);

          getUserDetails();
        }
      }, 20000);
    } catch (error) {
      setResend(false);
      toastify.error(error?.response?.data?.message);
    }
  };

  const handleUpdateRole = async (memberEmail, newRole) => {
    try {
      setUpdatingRole(true);
      await axios.put(
        `${API_SERVICE_BACKEND}/user-invites`,
        {
          sender_mail: userInfo?.email ?? user?.email,
          receiver_mail: memberEmail,
          role: newRole,
        }
      );

      toastify.success("Role updated successfully");
      setIsRoleUpdateOpen(false);
      setSelectedMemberForRoleUpdate(null);
      setUpdatingRole(false);
      getUserDetails();
    } catch (error) {
      toastify.error(error?.response?.data?.message || "Failed to update role");
      setUpdatingRole(false);
    }
  };

  const handleRemoveUser = async (deleteEmail) => {
    try {
      const validEmail = validateEmail(deleteEmail);
      if (!validEmail) {
        toastify.error("Invalid email!!");
        return;
      }
      const response = await axios.post(
        `${API_SERVICE_BACKEND}/delete-invite`,
        {
          sender_mail: user?.email,
          delete_mail: deleteEmail,
        }
      );
      if (!response.data.data) {
        toastify.warn(response.data.message);
        return;
      } else {
        toastify.success("Team member removed successfully");
        getUserDetails();
      }
    } catch (error) {
      toastify.error(error.message);
    }
  };
  const confirmRemoveUser = (deleteEmail) => {
    setSelectedEmail(deleteEmail);
    setIsDeleteOpen(true);
  };
  const handleConfirmDelete = () => {
    if (selectedEmail) {
      handleRemoveUser(selectedEmail); // Call existing function
      setIsDeleteOpen(false); // Close dialog after API call
    }
  };

  function formatTimestamp(timestamp) {

    const date = new Date(
      timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
    );

    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  }


  const { getUserInterfaceInfo } = useContext(SettingsContext);
  const handleNewInterfaceToggle = async (newValue) => {
    try {
      const baseURL = `${API_SERVICE_BACKEND}/updateUserInterface/${sessionStorage.getItem("userEmail")}`;
      const response = await axios.put(baseURL, { "newDesignInterface": newValue });
      if (response) {
        setIsNewInterfaceEnabled(newValue)
         localStorage.setItem(
        "isNewInterfaceEnabled",
        JSON.stringify(newValue)
      );
      //getUserInterfaceInfo();
      }
    } catch (error) {
      //console.log(error);
      toast.error(error?.response?.data?.error || error?.message);
    }
  }


  // Time zone 
  const [timezones, setTimezones] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({
    value: userTimezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const handleTimeZoneChange = async (newTimeZone) => {
    setSelectedCountry(newTimeZone);
    setUserTimezone(newTimeZone?.value ?? moment.tz.guess(true)); // Update the user's time zone in the context or state
  };
  // Function to get the current user's time zone
  const getUserTimezone = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setSelectedCountry(userTimezone); // Set the user's current time zone as the selected one
  };

  useEffect(() => {
    getUserTimezone(); // Set the current user's time zone when the component mounts

    const allTimezones = moment.tz.names().map((timezone) => {
      // Get UTC offset and abbreviation
      const time = moment.tz(timezone);
      const offset = time.utcOffset();
      const hoursOffset = Math.floor(offset / 60); // Hours offset
      const minutesOffset = Math.abs(offset % 60); // Minutes offset
      const formattedOffset = `UTC ${hoursOffset >= 0 ? '+' : '-'}${String(Math.abs(hoursOffset)).padStart(2, '0')}:${String(minutesOffset).padStart(2, '0')}`;
      // const currentTime = time.format('HH:mm');
      // Split timezone string to get the location name (e.g., Calcutta, New York)
      // const timeZoneParts = timezone.split('/');
      // const locationName = timeZoneParts[1] ? timeZoneParts[1].replace('_', ' ') : timezone;

      // Return time zone info
      return {
        value: timezone,
        offset: offset,  // Store offset for sorting
        //label: `(${formattedOffset}) ${timezone}`,
        label: `(${formattedOffset}) ${timezone}`,
      };
    });

    // Sort the time zones by UTC offset
    const sortedTimezones = allTimezones.sort((a, b) => a.offset - b.offset);

    setTimezones(sortedTimezones);

    // Set the default timezone if selectedCountry is not set
    const defaultTimezone = userTimezone; // Get the default timezone of the user

    if (defaultTimezone) {
      setSelectedCountry(sortedTimezones.find(
        (timezone) => timezone.value === userTimezone
      ));
    } else {
      // Fallback to user's timezone or first timezone
      const userTimezone = moment.tz.guess(); // Get the user's current timezone
      const userTimezoneObj = sortedTimezones.find(
        (timezone) => timezone.value === userTimezone
      );
      setSelectedCountry(userTimezoneObj); // Fallback to the first timezone if no match
    }
  }, [infoUser]);

  const getInvoiceData = async ({ page, limit = 5, searchAfter, endingBefore } = {}) => {
    try {
      setIsLoading(true);

      const res = await axios.post(
        `${API_SERVICE_BACKEND}/getInvoice`,
        {
          customerId: userInfo?.customerId,
          limit,

          ...(searchAfter ? { startingAfter: searchAfter } : {}),
          ...(endingBefore ? { ending_Before: endingBefore } : {}),
        },
      );

      const data = res.data?.data ?? res.data ?? [];
      const safeData = Array.isArray(data) ? data : [];
      setInvoiceData(safeData);
      setInvoiceTotal(res?.data?.total_count || 0);

      setHasMore(Boolean(res.data?.has_more ?? res.data?.hasMore));

      if (safeData.length > 0) {
        setFirstInvoiceId(safeData[0].id);
        setLastInvoiceId(safeData[safeData.length - 1].id);
      }

      // cache this page (if a page index was provided)
      if (typeof page === "number") {
        setInvoicePagesCache(prev => ({
          ...prev,
          [page]: {
            data: safeData,
            first: safeData[0]?.id || null,
            last: safeData[safeData.length - 1]?.id || null,
          },
        }));
      }
      // return useful metadata for callers that want to chain cursor-based requests
      return {
        data: safeData,
        first: safeData[0]?.id,
        last: safeData[safeData.length - 1]?.id,
        hasMore: Boolean(res.data?.has_more ?? res.data?.hasMore),
        total: res?.data?.total_count || 0,
      };
    } catch (error) {
      console.error("Invoice API failed", error);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    if (userInfo?.customerId) {
      setInvoicePagesCache({});
      setInvoicePage(1);
      getInvoiceData({ page: 1, limit: invoiceLimit });
    }
  }, [userInfo?.customerId]);




  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const { metaTitle, companyName, integrationsShow, whiteLableStatus, subUserStatus } = useContext(WhiteLabelConfigurationContext);
  const pageTitle = `Settings - ${metaTitle || companyName}`;

  return (
    <>
      <Seo title={pageTitle} />
      <div style={{ maxWidth: "100%" }}>
        <Box
          sx={{
            py: 0,
            
            mb: "14px"
          }}
        >
          <Tabs
            onChange={(e) => {
              const headerId = e.target.value;
              setActiveMenuItem(headerId);
              if (headerId === "section7") {
                setCalendarOptions((prev) => ({
                  ...prev,
                  target_id: "cronofy-calendar-sync",
                  element_token: calendarToken,
                }));

                setAvailabilityOptions((prev) => ({
                  ...prev,
                  target_id: "cronofy-availability-rules",
                  element_token: availabilityToken,
                }));
              }
            }}
            value={activeMenuItem}
            indicatorColor="primary"
            TabIndicatorProps={{
              style: {
                backgroundColor: props.errorTabs.includes(activeMenuItem)
                  ? "red"
                  : theme.palette.primary.main,
                height: 3, // optional for better visibility
              },
            }}

            scrollButtons="auto"
            textColor="primary"
            variant="scrollable"
            className="glass-tabs"
            sx={{
              backgroundColor: "white",
              border: "1px solid rgba(224, 224, 229, 1)",
              alignItems: "center",
              borderRadius: 1,
              p: 0.5,
              width: "100%",

              "& .MuiTabs-flexContainer": {
                gap: 0,
              },

              "& .MuiTab-root": {

                minHeight: "36px",
                p: 1,
                flexDirection: "row",
                gap: 0.5,
                textTransform: "none",
                fontSize: 14,
                borderRadius: 1,
                color: theme.palette.text.primary,
                "&.Mui-selected": {
                  color: theme.palette.primary.main,
                },
              },
            }}

          >

            {navHeader.map((header, index) => {
              const { headerTitle } = header;
              
              const isSubscriptionTab = headerTitle === "Subscription";
              const isIntegrationsTab = headerTitle === "Integrations";
              const isPurchasePlansTab = headerTitle === "Purchase Plans";
              
              // White-label sub-user restrictions
              if (
                userInfo?.isWhiteLabelSubUser &&
                (
                  isSubscriptionTab ||
                  isPurchasePlansTab ||
                  (!userInfo?.showIntegrations && isIntegrationsTab)
                )
              ) {
                return null;
              }
              
              // Stripe-managed subscription restrictions
              if (userInfo?.isSubscriptionStripeManaged && isPurchasePlansTab) {
                return null;
              }

              const errorTabs = Array.isArray(props.errorTabs) ? props.errorTabs : [];

              const hasError = errorTabs.includes(header.headerID);

              return (
                <Tab
                  key={header.headerID}
                  label={header.headerTitle}

                  value={header.headerID}
                  onClick={() => navigate(`?tab=${header.tabId}`)}
                  sx={{

                    ml: index > 0 ? 0.5 : 0,

                    color: hasError
                      ? "red !important"
                      : theme.palette.text.primary,
                    "&.Mui-selected": {

                      color: hasError
                        ? "red !important"
                        : theme.palette.primary.main,
                      fontWeight: 600,
                    },
                  }}

                />
              );
            })}

          </Tabs>
        </Box>
        <Dialog
          open={openCalenderDialog}
          onClose={handleCalenderDialogClose}
          fullWidth
          maxWidth="md"
        >
          {openCalenderDialog &&
            <CalenderView />
          }
        </Dialog>
        {
          <Stack
            spacing={4}
            {...props}
            sx={{
              width: "100%",
              pt: 0,
              height: "calc(100vh - 144px)",
              overflow: "auto",
            }}
            className="glass-scrollbar"
          >
            {activeMenuItem === "section1" && (
              <Stack
                gap={2}
                ref={section1Ref}
                id="section1"
                style={{ opacity: showAlert ? 0.5 : 1, height: "100%" }}
              >
                <Stack
                  direction={"row"}
                  gap={2}
                  justifyContent={"space-between"}
                  sx={{ flexWrap: "wrap", alignItems: "flex-start" }}
                >
                  <Stack sx={{ width: { xs: "100%", md: "49%" } }} gap={2}>
                    <Card
                      sx={{
                        width: "100%",
                        border: "1px solid #EAECF0",
                       
                        borderRadius: "8px",

                      }}
                      className="glass-wrapper"
                    >
                      <CardContent>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div style={{ display: "flex", marginBottom: "15px", alignItems: "center" }}>
                            <Typography
                              className="subHeadding"
                              sx={{ fontWeight: "700", color: theme.palette.text.primary }}
                            >
                              User Details
                            </Typography>
                          </div>
                        </div>
                        {/* <Divider /> */}
                        <Grid sx={{ marginTop: "0px" }}>
                          <Stack spacing={3}>
                            <Stack direction="row" spacing={3} alignItems="flex-start">
                              <div className="basicDetails">
                                <Typography
                                  sx={{
                                    marginBottom: "10px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary
                                  }}
                                >
                                  First Name <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <TextField
                                  value={userFirstName}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  disabled={showAlert ? true : false}
                                  sx={{ flexGrow: 1 }}
                                  spellCheck={true}
                                  onChange={(e) =>
                                    setUserFirstName(e.target.value)
                                  }
                                  error={!!props.firstNameError}
                                  helperText={props.firstNameError}
                                  className="glass-input"
                                />
                              </div>
                              <div className="basicDetails">
                                <Typography
                                  sx={{
                                    marginBottom: "10px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary
                                  }}
                                >
                                  Last Name <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <TextField
                                  value={userLastName}
                                  variant="outlined"
                                  size="small"
                                  disabled={showAlert ? true : false}
                                  fullWidth
                                  sx={{ flexGrow: 1 }}
                                  spellCheck={true}
                                  onChange={(e) =>
                                    setUserLastName(e.target.value)
                                  }
                                  className="glass-input"
                                  error={!!props.lastNameError}
                                  helperText={props.lastNameError}
                                />
                              </div>
                            </Stack>
                            <Stack direction="row" spacing={3} sx={{ marginTop: "16px" }}>
                              <Stack
                                direction="column"
                                sx={{ flex: 1 }}
                                spacing={1}
                              >
                                <Typography
                                  sx={{ color: theme.palette.text.primary, fontSize: "14px" }}
                                >
                                  Email Address
                                </Typography>
                                <TextField
                                  defaultValue={email}
                                  disabled
                                  variant="outlined"
                                  required
                                  sx={{ color: theme.palette.text.primary }}
                                  size="small"
                                  fullWidth
                                  InputProps={{
                                    startAdornment: (
                                      <EmailOutlinedIcon
                                        sx={{
                                          marginRight: "10px",
                                          width: "23px",
                                          fontSize: "28px",
                                          color: theme.palette.text.primary

                                        }} />
                                    ),
                                  }}
                                  className="glass-input"
                                />
                              </Stack>
                              <Stack direction="column" spacing={1} sx={{ flex: 1, }}>
                                <Typography
                                  sx={{ fontSize: "14px", color: theme.palette.text.primary }}
                                >
                                  Phone Number <span style={{ color: "red" }}>*</span>
                                </Typography>


                                <MuiTelInput
                                  disabled={showAlert ? true : false}
                                  value={userPhoneNumber}
                                  onChange={handleChange}
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  error={Boolean(props.phoneError)}
                                  helperText={props.phoneError}
                                  sx={{ flexGrow: 1 }}
                                  className="glass-input"
                                />
                              </Stack>
                            </Stack>

                            <TimeZoneComponent
                              handleTimeZoneChange={handleTimeZoneChange}
                              timezones={timezones}
                              selectedCountry={selectedCountry} />

                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  marginBottom: "15px",
                                  alignItems: "center"
                                }}
                              >
                                <Typography
                                  className="subHeadding"
                                  sx={{
                                    fontWeight: "700",
                                    color: theme.palette.text.primary,
                                  }}
                                >
                                  Change Your Password
                                </Typography>
                              </div>
                              {/* <Divider /> */}
                              <Grid xs={12} sm={12} md={8} sx={{ marginTop: "0px" }}>
                                <Stack direction="row" spacing={3}>
                                  <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        color: theme.palette.text.primary,
                                        fontWeight: 500,
                                      }}
                                    >
                                      Current Password
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      variant="outlined"
                                      placeholder="Enter Previous Password"
                                      spellCheck={true}
                                      type="password"
                                      disabled={showAlert ? true : false}
                                      size="small"
                                      value={prevPassword}
                                      sx={{
                                        flexGrow: 1,
                                        color: theme.palette.text.primary
                                      }}
                                      onChange={(e) => setPrevPassword(e.target.value)}
                                      className="glass-input"

                                    />
                                  </Stack>
                                  <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        color: theme.palette.text.primary,
                                        fontWeight: 500,
                                      }}
                                    >
                                      New Password
                                    </Typography>
                                    <TextField
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      spellCheck={true}
                                      placeholder="Enter New Password"
                                      type="password"
                                      value={newPassword}
                                      disabled={showAlert ? true : false}
                                      sx={{
                                        flexGrow: 1,
                                        color: theme.palette.text.primary
                                      }}
                                      onChange={handlePasswordChange}
                                      className="glass-input"

                                    />
                                    {passwordError && (
                                      <Typography color="error" sx={{ fontSize: "12px" }}>
                                        {passwordError}
                                      </Typography>
                                    )}

                                  </Stack>
                                </Stack>
                                <Box display="flex" justifyContent="flex-start" sx={{ marginTop: "14px" }}>
                                  <Button
                                    variant="contained"
                                    size="medium"
                                    onClick={handlePasswordUpdate}
                                    disabled={showAlert ? true : false}
                                    sx={{ minWidth: "auto" }}

                                  >
                                    Change Password
                                  </Button>
                                </Box>
                              </Grid>
                            </div>

                          </Stack>
                        </Grid>
                      </CardContent>
                    </Card>
                    {!userInfo?.hasTeamMemberLimitedAccess && <Card
                      sx={{
                        marginTop: "10px",
                        width: "100%",
                        border: "1px solid #EAECF0",
                        
                        borderRadius: "8px",
                      }}
                      className="glass-wrapper"
                    >
                      <CardContent>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginBottom: "15px",
                              alignItems: "center",
                              fontSize: "30px"
                            }}
                          >
                            <Typography
                              className="subHeadding"
                              sx={{ fontWeight: "700", fontSize: "16px", color: theme.palette.text.primary }}
                            >
                              Company Details
                            </Typography>
                          </div>
                          <Stack spacing={2} sx={{ mt: "5px" }}>

                            <CompanyLogoUpload
                              email={email}
                              companyLogo={userCompanyLogo}
                              showAlert={showAlert}
                            />


                            <Stack direction="row" spacing={3}>
                              {/* Company Name */}
                              <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
                                <Typography

                                  sx={{ fontSize: "14px", color: theme.palette.text.primary }}
                                >
                                  {" "}
                                  Company Name
                                </Typography>
                                <TextField
                                  fullWidth
                                  placeholder="Enter Company Name"
                                  variant="outlined"
                                  size="small"
                                  type="text"
                                  value={userCompanyName}
                                  disabled={showAlert ? true : false}
                                  spellCheck={true}
                                  sx={{
                                    flexGrow: 1,
                                  }}
                                  onChange={(e) =>
                                    setuserCompanyName(e.target.value)
                                  }
                                  className="glass-input"
                                />

                              </Stack>
                              <Stack
                                direction="column"
                                spacing={1}
                                sx={{ flex: 1 }}

                              >
                                <Typography

                                  sx={{ fontSize: "14px", color: theme.palette.text.primary }}
                                >
                                  Company Address
                                </Typography>
                                <TextField
                                  fullWidth
                                  size="small"
                                  variant="outlined"
                                  disabled={showAlert ? true : false}
                                  placeholder="Enter Company Address"
                                  type="text"
                                  value={userCompanyAddress}
                                  spellCheck={true}
                                  sx={{
                                    flexGrow: 1,
                                  }}
                                  onChange={(e) =>
                                    setuserCompanyAddress(e.target.value)
                                  }
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <HiOutlineLocationMarker
                                          style={{
                                            fontSize: "22px",
                                            color: theme.palette.text.primary,
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                  className="glass-input"
                                />
                              </Stack>
                            </Stack>
                          </Stack>
                        </div>
                      </CardContent>
                    </Card>}
                  </Stack>
                  <Stack sx={{ width: { xs: "100%", md: "49%" } }} gap={2}>


                    <SubscriptionCard
                      subscriptionDetails={subscriptionDetails}

                      userDetails={userInfo}
                      loading={false}
                      currentSubscription={currentSubscription}
                      setCurrentSubscription={setCurrentSubscription}
                      sx={{ alignItems: "flex-start" }}
                    />

                    {!userInfo?.hasTeamMemberLimitedAccess && <Card
                      sx={{
                        marginTop: "10px",
                        width: "100%",
                        border: "1px solid #EAECF0",
                        alignSelf: "flex-start",
                        borderRadius: "8px",
                      }}
                      className="glass-wrapper"
                    >
                      <CardContent>
                        {isLoading ? (
                          <Stack spacing={2}>
                            <Skeleton variant="text" width={150} />
                            <Skeleton variant="rectangular" height={30} />
                            <Skeleton variant="rectangular" height={30} />
                            <Skeleton variant="rectangular" height={30} />
                            <Skeleton variant="rectangular" height={30} />
                          </Stack>
                        ) : (
                          <>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                              <Typography variant="h6">
                                {`Invoices (Showing ${invoiceData.length} of ${invoiceTotal || 0})`}
                              </Typography>
                            </Box>

                            {invoiceData.length > 0 ? (
                              <Stack spacing={2}>
                                {invoiceData.map((invoice) => (
                                  <Box
                                    key={invoice.id}
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    padding="8px 0"
                                    borderBottom="1px solid #eee"
                                  >
                                    <Box display="flex" alignItems="center" gap={2}>
                                      <InsertDriveFileIcon sx={{ fontSize: 20, color: "text.secondary" }} />
                                      <Box>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                                          {`Invoice #${invoice.id.substring(0, 6).toUpperCase()}`}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                          {formatTimestamp(invoice.created)} •{" "}
                                          {currencyFormatter.format(invoice.amount_paid / 100)}
                                        </Typography>
                                      </Box>
                                    </Box>

                                    <Button
                                      size="small"
                                      startIcon={<DownloadIcon />}
                                      href={invoice.invoice_pdf}
                                      target="_blank"
                                      className="glass-button-tertiary"
                                    >
                                      Download
                                    </Button>
                                  </Box>
                                ))}
                              </Stack>
                            ) : (
                              <Typography
                                sx={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  textAlign: "center",
                                  paddingY: "10px",
                                  color: theme.palette.text.primary,
                                }}
                              >
                                No Invoices Found
                              </Typography>
                            )}
                            {invoiceData.length > 0 && (
                              <Box mt={2} mb={0} display="flex" justifyContent="center" alignItems="center" gap={1}>
                                <Pagination
                                  count={Math.max(1, Math.ceil((invoiceTotal || 0) / (invoiceLimit || 5)))}
                                  page={invoicePage}
                                  onChange={async (e, value) => {
                                    if (value === invoicePage) return;

                                    const limit = invoiceLimit || 5;

                                    // 1) If we already cached this page, just use it.
                                    const cachedPage = invoicePagesCache[value];
                                    if (cachedPage && Array.isArray(cachedPage.data)) {
                                      setInvoiceData(cachedPage.data);
                                      setFirstInvoiceId(cachedPage.first || null);
                                      setLastInvoiceId(cachedPage.last || null);
                                      setInvoicePage(value);
                                      return;
                                    }

                                    const diff = value - invoicePage;

                                    // ---------------- FORWARD (e.g. 1 -> 2 -> 3) ----------------
                                    if (diff > 0) {
                                      let currentLast = lastInvoiceId || invoiceData[invoiceData.length - 1]?.id;
                                      if (!currentLast) return;

                                      let currentPage = invoicePage;

                                      for (let step = 0; step < diff; step++) {
                                        if (!hasMore) break;

                                        const targetPage = currentPage + 1;

                                        // If this targetPage is cached, just move cursor/page and continue.
                                        const cached = invoicePagesCache[targetPage];
                                        if (cached && cached.last) {
                                          currentLast = cached.last;
                                          currentPage = targetPage;
                                          continue;
                                        }

                                        const res = await getInvoiceData({
                                          page: targetPage,
                                          limit,
                                          searchAfter: currentLast,
                                        });

                                        if (!res || !res.data || res.data.length === 0) break;

                                        currentLast = res.last;
                                        currentPage = targetPage;

                                        if (!res.hasMore) break;
                                      }

                                      // After loop, try to show the requested page from cache
                                      const finalPage = invoicePagesCache[value];
                                      if (finalPage && Array.isArray(finalPage.data)) {
                                        setInvoiceData(finalPage.data);
                                        setFirstInvoiceId(finalPage.first || null);
                                        setLastInvoiceId(finalPage.last || null);
                                      }

                                      setInvoicePage(value);
                                      return;
                                    }

                                    // ---------------- BACKWARD (e.g. 3 -> 2 -> 1) ----------------
                                    const steps = Math.abs(diff);
                                    let targetPageNumber = invoicePage - steps;
                                    if (targetPageNumber < 1) targetPageNumber = 1;

                                    const cached = invoicePagesCache[targetPageNumber];
                                    if (cached && Array.isArray(cached.data)) {
                                      setInvoiceData(cached.data);
                                      setFirstInvoiceId(cached.first || null);
                                      setLastInvoiceId(cached.last || null);
                                      setInvoicePage(targetPageNumber);
                                      return;
                                    }

                                    // If not cached, refetch from beginning up to the target page
                                    let cursor = null;
                                    let currentPage = 1;
                                    setInvoicePagesCache({});

                                    // load page 1
                                    const firstRes = await getInvoiceData({ page: 1, limit });
                                    if (!firstRes || !firstRes.data || firstRes.data.length === 0) {
                                      setInvoicePage(1);
                                      return;
                                    }
                                    cursor = firstRes.last;

                                    // load subsequent pages until we reach targetPageNumber
                                    while (currentPage < targetPageNumber && cursor) {
                                      const nextPage = currentPage + 1;
                                      const pageRes = await getInvoiceData({
                                        page: nextPage,
                                        limit,
                                        searchAfter: cursor,
                                      });

                                      if (!pageRes || !pageRes.data || pageRes.data.length === 0) break;

                                      cursor = pageRes.last;
                                      currentPage = nextPage;
                                    }

                                    const finalCached = invoicePagesCache[targetPageNumber];
                                    if (finalCached && Array.isArray(finalCached.data)) {
                                      setInvoiceData(finalCached.data);
                                      setFirstInvoiceId(finalCached.first || null);
                                      setLastInvoiceId(finalCached.last || null);
                                      setInvoicePage(targetPageNumber);
                                    } else {
                                      setInvoicePage(1);
                                    }
                                  }}
                                />
                              </Box>
                            )}
                          </>
                        )}
                      </CardContent>
                    </Card>}
                  </Stack>
                </Stack>
                <Stack
                  direction={"row"}
                  gap={2}
                  justifyContent={"space-between"}
                  sx={{ flexWrap: "wrap" }}
                >

                  {(!whiteLableStatus && !subUserStatus) && (
                    <Card
                      sx={{
                        marginTop: "10px",
                        width: { xs: "100%", md: "49%" },
                        border: "1px solid #EAECF0",
                        
                        borderRadius: "8px",
                      }}
                      className="glass-wrapper"
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 2,
                          height: "100%",
                          width: "75%",
                          justifySelf: "center"
                        }}
                      >
                        <Chip className="glass-chip" label="New" />
                        <Typography
                          sx={{
                            fontSize: "24px",
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            marginBottom: "12px",
                            letterSpacing: "-0.003em",
                          }}
                        >
                          Redesigned Interface
                        </Typography>
                        <Typography sx={{ fontSize: "14px", color: theme.palette.text.secondary, textAlign: "center" }}>
                          Experience our new glass-inspired design system, bringing clarity and depth to your workflow.
                        </Typography>
                        <Divider sx={{ width: "100%", my: 1 }} />
                        <Stack sx={{ width: "100%" }} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 500,
                              color: theme.palette.text.primary
                            }}
                          >
                            Enable new design
                          </Typography>
                          <CustomSwitch checked={isNewInterfaceEnabled} onChange={(e) => handleNewInterfaceToggle(e.target.checked)} />
                        </Stack>
                      </CardContent>
                    </Card>
                  )}
                </Stack>
              </Stack>
            )}

            {activeMenuItem === "section5" && (
              <Card sx={{ overflow: "visible", border: "1px solid #EAECF0",borderRadius:"8px",flexGrow:1}}
                className="glass-wrapper"
              >
                <CardContent sx={{ p: 2 }}>
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    ref={section5Ref}
                    id="section5"
                  >
                    <PricingPage fromSettings={true} userInfo={userInfo} />
                  </div>
                </CardContent>
              </Card>
            )}

            {activeMenuItem === "section7" && (
              <CalendarPanel
                section7Ref={section7Ref}
                conferencingLinked={conferencingLinked}
                handleConferencingLink={handleConferencingLink}
                calendarOptions={calendarOptions}
                email={email}
                availabilityElements={availabilityElements}
                userCampaigns={userCampaigns}
                location={location}
                navigate={navigate}
                userCampaignLoading={userCampaignLoading}
                activeSubTab={activeSubTab}
                setActiveSubTab={setActiveSubTab}
              />

            )}

            {activeMenuItem === "section9" && (
              (subUserStatus ? integrationsShow : true) && (
                <IntegrationSettings
                  email={email}
                  openModal={openModal}
                  section9Ref={section9Ref}
                  userCampaigns={userCampaigns}
                  loadUserCampaigns={loadUserCampaigns}
                  userCampaignLoading={userCampaignLoading}
                />
              )
            )}

            {activeMenuItem === "section10" && (
              <Card>
                <CardContent>
                  <div
                    ref={section10Ref}
                    id="section10"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "15px",
                      }}
                    >
                      <>
                        <LuCalendarPlus
                          style={{
                            marginRight: "10px",
                            fontSize: "22px",
                            color: theme.palette.primary.main,
                          }}
                        />
                      </>
                      <Typography
                        sx={{
                          fontWeight: "700",
                          fontSize: "16px",
                          color: theme.palette.text.primary
                        }}
                      >
                        AI Agent Calendars
                      </Typography>
                    </div>
                    <Divider />

                    <div style={{ marginTop: "20px" }}
                      className="glass-wrapper">
                      <Stack
                        sx={{
                          border: `1px solid ${theme.palette.divider}`,
                          borderRadius: "12px",
                          padding: "5px",
                        }}
                        gap={"5px"}
                      >
                        {userCampaigns?.map((campaign, index) => {
                          return (
                            <>
                              <Box
                                sx={{
                                  width: "100%",
                                  borderRadius: "12px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  paddingX: "10px",
                                }}
                              >
                                <Typography style={{ fontSize: "14px", color: theme.palette.text.primary }}>
                                  <b style={{ fontSize: "14px" }}>
                                    {" "}
                                    {campaign.companyName}
                                  </b>{" "}
                                  - {campaign.title}
                                </Typography>

                                <Button
                                  variant={"outlined"}
                                  sx={{
                                    color: theme.palette.text.primary,
                                    border: `1px solid ${theme.palette.divider}`,
                                    marginRight: "10px",
                                    marginLeft: "5px",
                                    fontSize: "14px",
                                  }}
                                  onClick={() => {
                                    navigate(
                                      `${location.pathname}?campaign_id=${campaign._id}&title=${campaign.title}`,
                                      { state: { extra: campaign.extra } }
                                    );
                                  }}
                                >
                                  View More
                                </Button>
                              </Box>
                            </>
                          );
                        })}
                      </Stack>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}

            {activeMenuItem === "section11" && (
              <EmailAccounts
                sectionRef={section11Ref}
                id="section11"
                userEmail={user?.email}
                userType={userType}
              />
            )}

            {activeMenuItem === "section13" && (
              <Card
                id="sectionInvites"
                sx={{ overflow: "visible", border: "1px solid #EAECF0", flexGrow:1,borderRadius:"8px" }}
                className="glass-wrapper"
              >
                <CardContent
                  sx={{
                    p: 2,
                    "&:last-child": {
                      pb: 1.5,
                    },
                  }}

                >
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    ref={section13Ref}
                    id="sectionInvites"
                  >
                    <div style={{ display: "flex", marginBottom: "8px", alignItems: "center", justifyContent: "space-between" }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <>
                          <AiOutlineLink
                            style={{
                              marginRight: "5px",

                              fontSize: "24px",
                              color: theme.palette.text.primary,
                            }} />
                        </>
                        <Typography
                          className="subHeadding"
                          sx={{ fontWeight: "700", color: theme.palette.text.primary }}
                        >
                          Team


                        </Typography>
                      </Box>
                      {/* <Box
                        sx={{
                          textAlign: "left",
                          ml: 1,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "13px",
                            fontWeight: 500,
                            color: (theme) => theme.palette.text.secondary,
                            lineHeight: "18px",
                            display: "inline",
                          }}
                        >
                          Easily add teammates and manage access in one place.{" "}
                          <Link
                            href={`${HELP_URL}/11532252-team-access-invite-manage-team-members`}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                              fontSize: "13px",
                              fontWeight: 600,
                              lineHeight: "18px",
                              color: (theme) => theme.palette.primary.main,
                              textDecoration: "none",
                              "&:hover": {
                                textDecoration: "underline",
                              },
                              display: "inline",
                            }}
                          >
                            Learn more
                          </Link>
                        </Typography>
                      </Box> */}
                      <HelperLink
                        helperText={"Easily add teammates and manage access in one place. "}
                        actionText={"Learn more"}
                        style={{
                          textAlign: "left",
                          ml: 1,
                        }}
                      />

                    </div>

                    <Grid>
                      <Grid>
                        <Stack spacing={3}>
                          <Stack direction="row" spacing={3} sx={{ alignItems: "flex-start" }}>
                            <div className="basicDetails" style={{ position: "relative", width: "100%", flex: 1 }}>
                              <Typography sx={{ marginBottom: "10px", fontSize: "14px", color: theme.palette.text.primary }}>
                                Email
                              </Typography>
                              <TextField
                                variant="outlined"
                                sx={{ width: "100%" }}
                                size="small"
                                fullWidth
                                placeholder="Enter Email Address"
                                value={emailInvites}
                                onChange={(e) => setEmailInvites(e.target.value)}
                                InputProps={{
                                  startAdornment: (
                                    <EmailOutlinedIcon
                                      sx={{
                                        marginRight: "10px",
                                        width: "23px",
                                        fontSize: "30px",
                                        color: theme.palette.text.primary
                                      }} />
                                  ),
                                  endAdornment: (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                      <FormControl size="small" className="glass-input" sx={{ minWidth: 120, py: 0, height: "28px" }}>
                                        <Select
                                          value={selectedRole}
                                          onChange={(e) => setSelectedRole(e.target.value)}
                                          sx={{
                                            height: "100%",
                                          }}
                                        >
                                          <MenuItem value="MEMBER" sx={{ fontSize: "16px" }}>Member</MenuItem>
                                          <MenuItem value="ADMIN" sx={{ fontSize: "16px" }}>Admin</MenuItem>
                                        </Select>
                                      </FormControl>
                                      <Button
                                        disabled={invite || resend}
                                        onClick={() => handleInvite()}
                                        sx={{
                                          height: "100%",
                                          borderRadius: "4px",
                                          borderLeft: "1px solid #1976d2",
                                          width: "130px",
                                          padding: "0",
                                          borderColor: theme.palette.primary.main,
                                          fontSize: "14px",
                                        }}
                                        variant="outlined"
                                        className="glass-button-secondary-25"
                                      >
                                        Invite Team
                                      </Button>
                                    </Box>
                                  ),
                                }}
                                className="glass-input"
                              />
                            </div>
                          </Stack>
                        

                          <Stack direction="column" spacing={2} sx={{ mt: 0 }}>
                            <Divider  sx={{ mb: 0 }}/>
                            {userData && userData?.length ? (
                              <Box>
                                <Typography
                                  className="subHeadding"
                                  sx={{
                                    fontWeight: "700",
                                    marginBottom: "8px",
                                    fontSize: "16px",
                                    color: theme.palette.text.primary
                                  }}
                                >
                                  Team Members List
                                </Typography>
                                <Divider />

                                 <Box
                                  sx={{
                                    maxHeight: "375px",
                                    overflowY: "auto",
                                    mt: 1,
                                    pr: 1,
                                    pt: 0
                                  }}
                                  component={Scrollbar}
                                  className="glass-scrollbar"
                                >

                                {userData?.map((data,index) => (
                                  <>
                                    {/* {//console.log("data ::: ::", data)} */}
                                    <Box
                                      sx={{
                                        border: "1px solid #EAECF0",
                                        borderRadius: "12px",
                                        padding: "5px",
                                        display: "flex",
                                        flexDirection: "row",
                                        mt: index === 0 ? 0.5 : 2,
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                      }}
                                      className="glass-wrapper-25"
                                      gap={"5px"}
                                    >
                                      <ListItem sx={{ flex: 1 }}>
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                                          <Typography
                                            style={{ fontSize: "14px", color: theme.palette.text.primary }}
                                          >
                                            <b>{data.invitationToCompanyName} </b>{" "}
                                            {data.invitationTo}
                                          </Typography>
                                          <Typography
                                            style={{ fontSize: "12px", color: theme.palette.text.secondary }}
                                          >
                                            Role: <b>{data.role || "MEMBER"}</b>
                                          </Typography>
                                        </Box>
                                      </ListItem>
                                      <ListItem>
                                          {isInviteAccepted(data.status) ? (
                                            <Chip
                                              label={"Accepted"}
                                              color={"success"}
                                              size="small"
                                              className={"glass-chip-success"}
                                            />
                                          ) : (
                                            <Chip
                                              sx={{
                                                textTransform: "capitalize",
                                              }}
                                              size="small"
                                              label={data.status}
                                              color={isInvitePending(data.status) ? "warning" : "error"}
                                              className={isInvitePending(data.status) ? "glass-chip-warning" : "glass-chip-error"}
                                            />
                                          )}
                                      </ListItem>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1
                                        }}
                                      >
                                        {user?.email === data?.inviteBy ? (
                                          <>
                                            {!userInfo?.hasTeamMemberLimitedAccess && isInviteAccepted(data.status) && (
                                              <Button
                                                disabled={updatingRole}
                                                style={{
                                                  fontSize: "14px",
                                                  whiteSpace: "nowrap",
                                                }}
                                                onClick={() => {
                                                  setSelectedMemberForRoleUpdate({
                                                    email: data.invitationTo,
                                                    currentRole: data.role || "MEMBER"
                                                  });
                                                  setIsRoleUpdateOpen(true);
                                                }}
                                                className="glass-button-secondary-25"
                                              >
                                                Update Role
                                              </Button>
                                            )}
                                            {isInvitePending(data.status) ? (
                                              <Button
                                                disabled={resend}
                                                style={{
                                                  width: "80px",
                                                  fontSize: "14px",
                                                }}
                                                onClick={() =>
                                                  handleResend(
                                                    data.invitationTo,
                                                    data.inviteByCompanyName,
                                                    data.role || "MEMBER"
                                                  )
                                                }
                                                className="glass-button-secondary-25"
                                              >
                                                Resend
                                              </Button>
                                            ) : (
                                              !isInviteAccepted(data.status) && <Box style={{ width: "80px" }}></Box>
                                            )}
                                            {!userInfo?.hasTeamMemberLimitedAccess && <Button
                                              onClick={() =>
                                                confirmRemoveUser(data.invitationTo)
                                              }
                                              className="glass-button-secondary-25"
                                            >
                                              Remove
                                            </Button>}
                                          </>
                                        ) : (
                                          <Tooltip
                                            title={`Insufficient permissions: This invitation was created by ${data?.inviteBy}. Only the original inviter can manage this team member.`}
                                            arrow
                                            placement="top"
                                          >
                                            <IconButton size="small">
                                              <InfoOutlined fontSize="small" />
                                            </IconButton>
                                          </Tooltip>
                                        )}
                                      </Box>
                                    </Box>
                                  </>
                                ))}
                                </Box>
                                <Dialog
                                  open={isDeleteOpen}
                                  onClose={() => setIsDeleteOpen(false)}
                                  aria-labelledby="alert-dialog-title"
                                  aria-describedby="alert-dialog-description"
                                >
                                  <DialogTitle
                                    id="alert-dialog-title"
                                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                  >
                                    <Typography variant="h6" sx={{ display: "flex", alignItems: "center", color: theme.palette.text.primary }}>

                                      Remove User
                                    </Typography>
                                    <IconButton onClick={() => setIsDeleteOpen(false)} sx={{ color: theme.palette.text.primary }}>
                                      <CloseOutlined />
                                    </IconButton>
                                  </DialogTitle>

                                  <DialogContent>
                                    <DialogContentText
                                      id="alert-dialog-description"
                                      sx={{ fontSize: "18px", color: theme.palette.text.primary }}
                                    >
                                      Are you sure you want to remove this user?
                                    </DialogContentText>
                                  </DialogContent>

                                  <DialogActions>
                                    <Button
                                      sx={{ borderRadius: 1 }}
                                      className="glass-button-secondary-50"
                                      onClick={() => setIsDeleteOpen(false)}
                                      variant="outlined"
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      variant="contained"
                                      sx={{ borderRadius: 1, backgroundColor: "red", "&:hover": { backgroundColor: "#e30000" } }}
                                      onClick={handleConfirmDelete}
                                    >
                                      Remove
                                    </Button>
                                  </DialogActions>
                                </Dialog>

                                <Dialog
                                  open={isRoleUpdateOpen}
                                  onClose={() => {
                                    setIsRoleUpdateOpen(false);
                                    setSelectedMemberForRoleUpdate(null);
                                  }}
                                  aria-labelledby="role-update-dialog-title"
                                >
                                  <DialogTitle
                                    id="role-update-dialog-title"
                                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                  >
                                    <Typography variant="h6" sx={{ display: "flex", alignItems: "center", color: theme.palette.text.primary }}>
                                      Update Role
                                    </Typography>
                                    <IconButton 
                                      onClick={() => {
                                        setIsRoleUpdateOpen(false);
                                        setSelectedMemberForRoleUpdate(null);
                                      }} 
                                      sx={{ color: theme.palette.text.primary }}
                                    >
                                      <CloseOutlined />
                                    </IconButton>
                                  </DialogTitle>

                                  <DialogContent>
                                    <Box sx={{ minWidth: 300, mt: 1 }}>
                                      <Typography sx={{ marginBottom: "10px", fontSize: "14px", color: theme.palette.text.primary }}>
                                        Select Role
                                      </Typography>
                                      <FormControl fullWidth size="small">
                                        <Select
                                          value={selectedMemberForRoleUpdate?.currentRole || "MEMBER"}
                                          onChange={(e) => {
                                            setSelectedMemberForRoleUpdate({
                                              ...selectedMemberForRoleUpdate,
                                              currentRole: e.target.value
                                            });
                                          }}
                                          className="glass-input"
                                          sx={{
                                            "& .MuiOutlinedInput-notchedOutline": {
                                              borderColor: theme.palette.divider,
                                            },
                                          }}
                                        >
                                          <MenuItem value="MEMBER">Member</MenuItem>
                                          <MenuItem value="ADMIN">Admin</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </Box>
                                  </DialogContent>

                                  <DialogActions>
                                    <Button
                                      sx={{ borderRadius: 1 }}
                                      className="glass-button-secondary-50"
                                      onClick={() => {
                                        setIsRoleUpdateOpen(false);
                                        setSelectedMemberForRoleUpdate(null);
                                      }}
                                      variant="outlined"
                                      disabled={updatingRole}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      variant="contained"
                                      sx={{ borderRadius: 1 }}
                                      onClick={() => {
                                        if (selectedMemberForRoleUpdate) {
                                          handleUpdateRole(
                                            selectedMemberForRoleUpdate.email,
                                            selectedMemberForRoleUpdate.currentRole
                                          );
                                        }
                                      }}
                                      disabled={updatingRole}
                                    >
                                      {updatingRole ? <CircularProgress size={20} /> : "Update"}
                                    </Button>
                                  </DialogActions>
                                </Dialog>

                              </Box>
                            )
                              : (
                                ""
                              )}
                          </Stack>
                        </Stack>
                      </Grid>
                    </Grid>
                  </div>

                </CardContent>
              </Card>

            )}

            {activeMenuItem === "section14" && (
              <BlackList userEmail={user?.email} />
            )}

            {activeMenuItem === "section15" && <CampaignSchedule />}

            {activeMenuItem === "section16" && userInfo && (
              <Credits userEmail={user?.email} userDetails={userInfo} getAccessToken={getAccessToken} />
            )}
            {activeMenuItem === "section17" && (
              <AibdrDetails sectionRef={section17Ref} id="section17" />
            )}
          </Stack>
        }
      </div>
    </>
  );
};

AccountGeneralSettings.propTypes = {
  avatar: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};
